import React, { useCallback, useEffect, useMemo, useReducer, useRef, useState } from 'react';

import { Empty, Row, Col, Select, Typography, Space, Table, DatePicker, TimePicker, Tooltip, message, Spin, Popover, Avatar, Card,  Radio, Button, Drawer, Form, Checkbox, Tag, Input, Modal } from 'antd';
import { Content } from 'antd/es/layout/layout';
import { useNavigate, useLocation } from 'react-router-dom';
import { EyeOutlined, FundViewOutlined, InfoOutlined, FilterOutlined, PlusOutlined, CloseCircleOutlined, InfoCircleOutlined, SoundOutlined } from '@ant-design/icons';
import { LayersControl, Marker, Polyline, Popup } from 'react-leaflet';
// import PropTypes from 'prop-types';
import { useAuth } from '../Context';
import realtimedetectiondata from './reducer';
import { ADD_COORDINATE_DETAILS, ADD_COORDINATE_DETAILS_ERROR, ADD_COORDINATE_DETAILS_SUCCESS, AIS_NAME_FILTER, AIS_NAME_FILTER_ERROR, AIS_NAME_FILTER_SUCCESS, ASN_DATA_LIST_ERROR, ASN_DATA_LIST_SUCCESS,  COORDINATE_LIST_ERROR, COORDINATE_LIST_SUCCESS, DETECTION_ALGORITHM_LIST, DETECTION_ALGORITHM_LIST_ERROR, DETECTION_ALGORITHM_LIST_SUCCESS, MODAL_DATA_LIST, MODAL_DATA_LIST_ERROR, MODAL_DATA_LIST_SUCCESS, MULTIPLEMODEL_LIST_ERROR, MULTIPLEMODEL_LIST_SUCCESS, REALTIME_DETECTION_LIST, REALTIME_DETECTION_LIST_ERROR, REALTIME_DETECTION_LIST_SUCCESS, UPDATE_REALTIME_DETECTION_LIST, UPDATE_REALTIME_DETECTION_LIST_DETAILS, UPDATE_REALTIME_DETECTION_LIST_DETAILS_ERROR, UPDATE_REALTIME_DETECTION_LIST_DETAILS_SUCCESS, UPDATE_REALTIME_DETECTION_LIST_ERROR, UPDATE_REALTIME_DETECTION_LIST_SUCCESS, } from './constants';
import axios from 'axios';
import dayjs from 'dayjs';
import { datetimeCovertertolocal } from '../datetime-converter';
import SeaMap, { vesselCpaIcon } from './SeaMap';
import GoogleMap from '../Map/map';
import DetectionInfoModal from './DetectionInfoModal';

import englan from '../../english.json';
import germanlan from '../../german.json';
import arabiclan from '../../arabic.json';
import frenchlan from '../../french.json';
import hindilan from '../../hindi.json';
import malayalamlan from '../../malayalam.json';
import { useFormik } from 'formik';
import moment from 'moment';


const { Title } = Typography;


const { RangePicker } = DatePicker;

// Algorithm-keyed color palette for the map view (mirrors GMap.jsx's algorithmColors).
const ALGORITHM_COLORS = ['#FF0000', '#0000FF', '#00AA00', '#FF9900', '#9900FF', '#00AAAA', '#FF00AA', '#795548', '#607D8B', '#8BC34A'];

// ============================================================
// DETERMINISTIC ALGORITHM ID -> COLOR (mirrors the identical helper in
// SeaMap.jsx). A given algorithm ID must always resolve to the exact
// same color regardless of the order the currently-loaded detections
// happen to be in — a pure hash of the ID guarantees that, unlike the
// previous "first algorithm encountered gets color 0" approach, which
// could make the very same algorithm map to a different color depending
// on data order and made points/lines look mismatched.
// ============================================================
const colorForAlgorithmId = (id) => {
	if (id === undefined || id === null || id === '') return null;
	const str = String(id);
	let hash = 0;
	for (let i = 0; i < str.length; i += 1) {
		hash = (hash * 31 + str.charCodeAt(i)) >>> 0;
	}
	return ALGORITHM_COLORS[hash % ALGORITHM_COLORS.length];
};

// Color of the moving "PLAY" trail line — same as RealtimeDetectionDetails.jsx.
const linecolor = { color: 'green' };

// Same green, but dotted — used for the moving PORT trail during PLAY.
const portLinecolor = { color: 'green', dashArray: '2,10', lineCap: 'round' };

// PERFORMANCE: constant (module-level) props handed to <SeaMap />. Previously
// these were fresh object literals on every render of this component, which
// defeated SeaMap's React.memo and made it re-render (and re-reconcile its
// whole tree) on every parent state change (e.g. every Play tick).
const SEAMAP_STYLE = { height: '100%' };
const SEAMAP_CONTAINER_PROPS = { scrollWheelZoom: true };
const EMPTY_ARRAY = [];

let realtimedetection_data_pagination = {};

// ---- Filter persistence for the details round-trip ONLY ----
// Module-level (NOT component state), same pattern as
// `realtimedetection_data_pagination` above, so it survives this component
// unmounting/remounting during SPA navigation and resets on a hard refresh.
//
// IMPORTANT (behavior change): this snapshot is now written in exactly ONE
// place — `showMap()`, i.e. the moment the user clicks the eye icon to open
// `/realtimedetection-details` — and it is CONSUMED (read once, then cleared)
// on the next mount of this component. That means:
//
//   • Realtime Detection -> details -> back  => filters restored exactly.
//   • Realtime Detection -> any other module (Dashboard, Alarms, Reports,
//     ...) -> back to Realtime Detection    => no snapshot was ever written
//     for that trip, so the page mounts with its default filters.
//   • details -> back -> some other module -> back again => the snapshot was
//     already consumed and cleared on the first return, so this second visit
//     also starts from defaults.
//
// Previously this object was rewritten on every filter/state change, so ANY
// later return to the page (from anywhere in the app) restored stale filters.
let realtimedetection_filter_state = null;

export default function RealtimeDetection() {

	const { state } = useLocation();
	const [form] = Form.useForm();

	// Snapshot captured ONCE, on this component's very first render. If the
	// user arrived here from the details page, `realtimedetection_filter_state`
	// holds the filters they left with; otherwise it is null and every filter
	// below falls back to its default. The module-level variable is cleared in
	// the mount effect further down, so it can never leak into a later visit.
	const restoredFilterState = useRef(realtimedetection_filter_state).current;

	const dashboardtype = process.env.REACT_APP_IDENTIFIER;
	const authtoken = localStorage.getItem(`${dashboardtype.toUpperCase()}_ACCESS_TOKEN`);
	const {getRegion, regiondata, getUserAllocation ,getUserAllocationData,getPids,pidsData,channelData, getChannels, handleGetMapdata, mapdata, optionalpipedata, handleOptionalPipelinedata} = useAuth();
	const initalState = {realtimedetection_data:[],users_data:[],coordinates:[],modaldata:[], details: null, pending: false, error: false,multimod:[],asndata:[],detectionalgorithm:[],ais_name:[], pagination: { total: 0, limit: 10, skip: 0, current:1 }};
	const [realtimedetection_data, dispatch] = useReducer(realtimedetectiondata, initalState);
	const [modalOpen, setModalOpen] = useState(false);

	// ---- Info modal (shows selected keys of a detection record) ----
	const [infoModalOpen, setInfoModalOpen] = useState(false);
	const [infoRecord, setInfoRecord] = useState(null);
	
	const customstart = localStorage.getItem(`${dashboardtype.toUpperCase()}_START_TIME`);
	const customend = localStorage.getItem(`${dashboardtype.toUpperCase()}_END_TIME`);
	const startDate = moment().startOf('day');
	const endDate = moment().endOf('day');
	

	// ---- Date/Time helpers (mirror AlarmReport.jsx's getTimeValue / EndTimeValue) ----
	const getTimeValue = (customTime) => {
		const time = customTime ? customTime : '00:00:00';
		const parts = time.split(':').map(Number);
		const [h = 0, m = 0, s = 0] = parts;
		return dayjs().set('hour', h).set('minute', m).set('second', s);
	};

	const getEndTimeValue = (customTime) => {
		const time = customTime ? customTime : '23:59:59';
		const parts = time.split(':').map(Number);
		const [h = 0, m = 0, s = 0] = parts;
		return dayjs().set('hour', h).set('minute', m).set('second', s);
	};

	// ---- Advanced options (mirrors AlarmReport.jsx / RealtimeAlarm module) ----
	// Seeded from `restoredFilterState` (only set when we're returning from the
	// details page) instead of hardcoded defaults, so the drawer's controls
	// come back exactly as you left them on that round-trip — and only then.
	const [timeSelection, setTimeSelection] = useState(
		restoredFilterState?.timeSelection !== undefined
			? restoredFilterState.timeSelection
			: (state && (state.data.startdatetime || state.data.enddatetime) ? true : false)
	);
	const [filterLastHour, setFiltetLastHour] = useState(
		restoredFilterState?.filterLastHour ?? 1
	);
	const [advDateRange, setAdvDateRange] = useState(
		restoredFilterState?.advDateRange ?? [
			state && state.data.startdatetime ? dayjs(state.data.startdatetime) : dayjs().subtract(30, 'day'),
			state && state.data.enddatetime ? dayjs(state.data.enddatetime) : dayjs()
		]
	);
	const [startTime, setStartTime] = useState(
		restoredFilterState?.startTime ?? getTimeValue(customstart)
	);
	const [endTime, setEndTime] = useState(
		restoredFilterState?.endTime ?? getEndTimeValue(customend)
	);

	const navigate = useNavigate();
	const [regionId, setRegionId] = useState(
		restoredFilterState?.regionId !== undefined
			? restoredFilterState.regionId
			: (state && state.data.regionId ? state && state.data.regionId : null)
	);
	const pipelineId = localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) ? localStorage.getItem(`${dashboardtype.toUpperCase()}_pipelineId`) : null;
	const [pidsFilter, setpidsFilter] = useState(
		restoredFilterState?.pidsFilter !== undefined ? restoredFilterState.pidsFilter : 1
	);
	const [channelsdata, setchannels] = useState(
		restoredFilterState?.channelsdata !== undefined ? restoredFilterState.channelsdata : null
	);
	const [chains, setchains] = useState(
		restoredFilterState?.chains !== undefined ? restoredFilterState.chains : null
	);
	const [algorithm, setalgorithm] = useState(
		restoredFilterState?.algorithm !== undefined ? restoredFilterState.algorithm : null
	);
	const [trajectory, settrajectory] = useState(
		restoredFilterState?.trajectory !== undefined ? restoredFilterState.trajectory : null
	);
	const permission = localStorage.getItem(`${dashboardtype.toUpperCase()}_PERMISSION`);
	const admin_roles = ['superadmin','admin','Station-In-Charge','Pipeline-HO','Pipeline-In-Charge','HQO-HSE'];
	const [allocationId, setAllocationId] = useState(
		restoredFilterState?.allocationId !== undefined
			? restoredFilterState.allocationId
			: (state && state.data.regionId ? state && state.data.regionId : null)
	);
	const apiUrl = localStorage.getItem(`${dashboardtype.toUpperCase()}_API_URL`);
	const api = apiUrl && apiUrl ? apiUrl : process.env.REACT_APP_CORE_HOST;

	const envTimeout = process.env.REACT_APP_TIMEOUT == undefined || process.env.REACT_APP_TIMEOUT == 'undefined' ? 5000 : process.env.REACT_APP_TIMEOUT;
	const timeout = localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`) == 'undefined' ? parseInt(envTimeout) :  parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_TIMEOUT`));
	const envdateformat = process.env.REACT_APP_DATE_FORMAT == undefined || process.env.REACT_APP_DATE_FORMAT == 'undefined' ? 'YYYY-MM-DD' : process.env.REACT_APP_DATE_FORMAT;
	const settingsdateformat = localStorage.getItem(`${dashboardtype.toUpperCase()}_DATE_FORMAT`) == 'null' || localStorage.getItem(`${dashboardtype.toUpperCase()}_DATE_FORMAT`) == 'undefined' ? envdateformat : localStorage.getItem(`${dashboardtype.toUpperCase()}_DATE_FORMAT`);
	const langid = localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) && localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`) ? parseInt(localStorage.getItem(`${dashboardtype.toUpperCase()}_LANGUAGE_ID`)) : 2;
	const langdata = langid && langid ==1 ? arabiclan : langid ==2 ? englan : langid ==3 ? frenchlan : langid ==4 ? germanlan : langid ==5 ? hindilan : langid == 6 ? malayalamlan : englan;
	const featuresModule = JSON.parse(localStorage.getItem(`${dashboardtype.toUpperCase()}_FEATURES_MODULE_DASHBOARD`));
	const map_type = localStorage.getItem(`${dashboardtype.toUpperCase()}_MAP_TYPE`);

	// ---- List / Map toggle + side filter drawer (mirrors AlarmReport.jsx's List/Map pattern) ----
	// `view` is also part of the details round-trip snapshot, so toggling to
	// Map, going into a detection's details, and coming back keeps you on Map
	// view — while arriving from any other module starts on List again.
	const [view, setView] = useState(restoredFilterState?.view ?? 'List');
	const [filterDrawer, setFilterdrawer] = useState(false);
	const [showAddCoordinateModal, setShowAddCoordinateModal] = useState(false);
	const [aisNameFilter, setAisNameFilter] = useState([]);

	// ---- Locally-deleted coordinate ids (optimistic UI only) ----
	// The DELETE API is NOT wired up yet. Clicking "Yes, delete" inside a
	// plotted coordinate's popup (see CoordinateDeleteActions in SeaMap.jsx)
	// calls handleDeleteCoordinate below, which — for now — just records the
	// id here. coordinateMarkers (below) filters these ids out, so the
	// marker disappears from the map immediately. Once the real DELETE
	// endpoint is ready, swap the body of handleDeleteCoordinate for an
	// actual axios.delete call (see the TODO comment inside it); this state
	// and the filtering can stay exactly as-is for optimistic UI, or be
	// replaced by simply re-calling loadCoordinate() after a successful
	// server-side delete.
	const [deletedCoordinateIds, setDeletedCoordinateIds] = useState([]);

	// ---- Resolve the effective { start, end } Date range from the CURRENT draft
	// advanced-options state (timeSelection / advDateRange / startTime / endTime /
	// filterLastHour). Used only at mount (to seed the applied state, when there
	// is no restored snapshot) and at "Apply" time (handleFilterDetection) —
	// mirrors AlarmReport.jsx, where the date range used for the request is only
	// (re)computed when the filter is actually applied, not on every
	// keystroke/selection. ----
	const computeDateRange = () => {
		if (timeSelection) {
			const sDate = advDateRange && advDateRange[0] ? advDateRange[0] : dayjs();
			const eDate = advDateRange && advDateRange[1] ? advDateRange[1] : dayjs();
			const sTime = startTime || getTimeValue(customstart);
			const eTime = endTime || getEndTimeValue(customend);

			const combinedStart = dayjs(sDate)
				.set('hour', sTime.hour())
				.set('minute', sTime.minute())
				.set('second', sTime.second())
				.set('millisecond', 0);

			const combinedEnd = dayjs(eDate)
				.set('hour', eTime.hour())
				.set('minute', eTime.minute())
				.set('second', eTime.second())
				.set('millisecond', 999);

			return { start: combinedStart.toDate(), end: combinedEnd.toDate() };
		}

		const now = dayjs();
		return { start: now.subtract(filterLastHour, 'hour').toDate(), end: now.toDate() };
	};

	// ---- "Applied" filter state — this is what actually drives the API request.
	// It only changes when the user clicks "Apply" in the filter drawer
	// (handleFilterDetection), exactly like AlarmReport.jsx's filter values are
	// only committed to a fetch on its "Apply" button. Seeded from the restored
	// snapshot when returning from the details page, so re-mounting the
	// component does NOT re-fetch with reset filters in that case. ----
	const [appliedPidsFilter, setAppliedPidsFilter] = useState(
		restoredFilterState?.appliedPidsFilter !== undefined ? restoredFilterState.appliedPidsFilter : pidsFilter
	);
	const [appliedChannelsdata, setAppliedChannelsdata] = useState(
		restoredFilterState?.appliedChannelsdata !== undefined ? restoredFilterState.appliedChannelsdata : channelsdata
	);
	const [appliedChains, setAppliedChains] = useState(
		restoredFilterState?.appliedChains !== undefined ? restoredFilterState.appliedChains : chains
	);
	const [appliedAlgorithm, setAppliedAlgorithm] = useState(
		restoredFilterState?.appliedAlgorithm !== undefined ? restoredFilterState.appliedAlgorithm : algorithm
	);
	const [appliedTrajectory, setAppliedTrajectory] = useState(
		restoredFilterState?.appliedTrajectory !== undefined ? restoredFilterState.appliedTrajectory : trajectory
	);
	const [appliedStartDate, setAppliedStartDate] = useState(() =>
		restoredFilterState?.appliedStartDate ?? computeDateRange().start
	);
	const [appliedEndDate, setAppliedEndDate] = useState(() =>
		restoredFilterState?.appliedEndDate ?? computeDateRange().end
	);
	const [appliedaisNameFilter, setAppliedaisNameFilter] = useState(aisNameFilter);

	const [reportFilter, setFilter] = useState({pidsinfoId: null, channelId: null, }); 

	let pidsfilter=[];
	let pids=[];

	pidsData && pidsData.map((pid)=>{
		pids.push({
			value:pid.id,
			label:pid.name.toUpperCase()});
	});

	pidsData && pidsData.map((pid)=>{
		pidsfilter.push({
			value:pid.id,
			label:pid.name.toUpperCase()});
	});


	let channels=[];
	let chain=[];
	let algorithamOptions =[{value: null , label : langdata && langdata.ALL ? langdata.ALL :  'ALL'}];

	let trajectoryOptions =[
		
		{
			value: null,
			label: `${langdata && langdata.Normal ? langdata.Normal:'Normal'}`,
		},
		{
			value: true,
			label: `${langdata && langdata.Corrected ? langdata.Corrected:'Corrected'}`,
		},
	];

	const lastHours = [
		{ value: 1, label: `1 ${langdata && langdata.Hour ? langdata.Hour : 'Hour'}` },
		{ value: 2, label: `2 ${langdata && langdata.Hours ? langdata.Hours : 'Hours'}` },
		{ value: 3, label: `3 ${langdata && langdata.Hours ? langdata.Hours : 'Hours'}` },
		{ value: 6, label: `6 ${langdata && langdata.Hours ? langdata.Hours : 'Hours'}` },
		{ value: 12, label: `12 ${langdata && langdata.Hours ? langdata.Hours : 'Hours'}` },
		{ value: 24, label: `24 ${langdata && langdata.Hours ? langdata.Hours : 'Hours'}` },
	];



	realtimedetection_data.multimod && realtimedetection_data.multimod.map((item) => {
		chain.push({
			value : item.id,
			label : item?.name ? item.name : '',
		});
	});
	let aisNameOptions =[{value: null , label : langdata && langdata.ALL ? langdata.ALL :  'ALL'}];
	realtimedetection_data.ais_name && realtimedetection_data.ais_name.map((item) => {
		
		aisNameOptions.push({
			value : item.name ? item.name : null,
			label : item?.name ? item.name : '',
		});
	});

	realtimedetection_data.detectionalgorithm && realtimedetection_data.detectionalgorithm.map((item) => {
		
		algorithamOptions.push({
			value : item.id,
			label : item?.name ? item.name : '',
		});
	});



	channelData && channelData.map((item) => {
		channels.push({
			value : item.channelId,
			label : item.name,
		});
	});

	const disabledDate = (current) => {
		return current && current > dayjs().endOf('day');
	};

	// ---- Advanced-options handlers (draft only — do not trigger a fetch) ----
	const changeTimeSelection = (e) => {
		setTimeSelection(e.target.checked);
	};

	const handleLastHour = (value) => {
		setFiltetLastHour(value);
	};

	const handleAdvDateRange = (dates) => {
		if (dates) {
			setAdvDateRange([dates[0], dates[1]]);
		}
	};

	const handleStartTime = (time) => {
		if (time) {
			setStartTime(time);
		}
	};

	const handleEndTime = (time) => {
		if (time) {
			setEndTime(time);
		}
	};

	const columns = [
		{
			title: `${langdata && langdata.eventType ? langdata.eventType : 'Event Type'}`,
			dataIndex: 'eventType',
			key: 'eventType',
		},

		{
			title: `${langdata && langdata.PidsName ? langdata.PidsName : 'Pids Name'}`,
			dataIndex: 'pidsinfoId',
			key: 'pidsinfoId',
			render: (pidsinfoId) => {
				return (
					pidsfilter.find(
						(item) => item.value === pidsinfoId
					)?.label || ''
				);
			}
		},

		...(
			['superadmin'].includes(permission)
				? [
					{
						title: `${langdata && langdata.channelName ? langdata.channelName : 'Channel Name'}`,
						dataIndex: 'channelName',
						key: 'channelName',
					}
				]
				: []
		),

		{
			title: langdata?.distanceRange
				? langdata.distanceRange + ' (m)'
				: 'Distance Range (m)',
			dataIndex: 'distanceRange',
			key: 'distanceRange',
			render: (record) => (
				<Space wrap>
					{record?.length ? (
						record.map((item, index) => {
							const newItem = item!== null ? item !== 0 ?  Number(item).toFixed(2) : item : 'No Data';

							return (
								<Tag
									color="blue"
									key={index}
									style={{ cursor: 'pointer' }}
								>
									{newItem}
								</Tag>
							);
						})
					) : (
						<Tag color="yellow">
					Nil
						</Tag>
					)}
				</Space>
			)
		},
		{
			title: langdata?.depthRange
				? langdata.depthRange + ' (m)'
				: 'Depth Range (m)',
			dataIndex: 'depthRange',
			key: 'depthRange',
			render: (record) => (
				<Space wrap>
					{record?.length ? (
						record.map((item, index) => {
							const newItem = item!== null ? item !== 0 ?  Number(item).toFixed(2) : item : 'No Data';

							return (
								<Tag
									color="purple"
									key={index}
									style={{ cursor: 'pointer' }}
								>
									{newItem}
								</Tag>
							);
						})
					) : (
						<Tag color="yellow">
					Nil
						</Tag>
					)}
				</Space>
			)
		},

		// Show Detection Algorithm only for superadmin/admin
		...(
			['superadmin'].includes(permission)
				? [
					{
						title: langdata?.DetectionAlgorithm
							? langdata.DetectionAlgorithm
							: 'Detection Algorithm',
						dataIndex: 'detectionAlgorithmTypeName',
						key: 'detectionAlgorithmTypeName',
					}
				]
				: []
		),

		{
			title: langdata?.peakDistance
				? langdata.peakDistance + ' (m)'
				: 'Peak Distance (m)',
			dataIndex: 'peakDistance',
			key: 'peakDistance',
		},

		{
			title: langdata?.DateTime
				? langdata.DateTime
				: 'Date Time',
			dataIndex: 'starttime',
			key: 'starttime',
		},

		{
			title: langdata?.Actions
				? langdata.Actions
				: 'Actions',
			key: 'action',
			align: 'center',
			render: (_, record) => (
				<Space
					style={{
						justifyContent: 'center',
						display: 'flex'
					}}
					size="middle"
				>
					<a
						title={
							langdata?.ViewSpectrogram
								? langdata.ViewSpectrogram
								: 'View Spectrogram'
						}
						onClick={() => {
							showSpectrogram(record);
						}}
					>
						<SoundOutlined />
					</a>
					<a
						title={
							langdata?.ViewRealtimeDetection
								? langdata.ViewRealtimeDetection
								: 'View Realtime Detection'
						}
						onClick={() => {
							showMap(record);
						}}
					>
						<EyeOutlined />
					</a>
					<a
						title={langdata?.Info ? langdata.Info : 'Info'}
						onClick={() => {
							openInfoModal(record);
						}}
					>
						<InfoCircleOutlined />
					</a>
					{/* <Space>&nbsp;&nbsp;</Space> */}
					<a
						title={
							langdata?.HideDetection
								? langdata.HideDetection
								: 'Hide Detection'
						}
						onClick={() => {
							openShowAttachments(record);
						}}
					>
						
						<CloseCircleOutlined />
					</a>
				</Space>
			)
		}
	];



	const loadModalData = (record) => {
		dispatch({ type: MODAL_DATA_LIST });


		const config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/realtimedetectiondetailsapi/${record.id}?pidsinfoId=${record.pidsinfoId}`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization: `Bearer ${authtoken}`
			}
		};

		axios
			.request(config)
			.then((response) => {
				if (response.status === 200) {
				// accept a plain record or a { data: {...} } wrapper
					const payload =
					response.data && response.data.data && !Array.isArray(response.data.data)
						? response.data.data
						: response.data;
					dispatch({
						type: MODAL_DATA_LIST_SUCCESS,
						payload,
						trajectoryBoolean: trajectory, // picks detectionResults vs correctedDetectionResults
					});
				} else {
					dispatch({ type: MODAL_DATA_LIST_ERROR });
				}
			})
			.catch((error) => {
				dispatch({ type: MODAL_DATA_LIST_ERROR });
				message.config({ duration: 5, maxCount: 1 });
				if (error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication : 'It seems the network is unreachable. Please refresh the application.',
					});
				} else {
					message.open({
						type: 'error',
						content: `${langdata && langdata.SomethingWentWrong ? langdata.SomethingWentWrong : 'Something Went Wrong!'}`,
					});
				}
			});
	};

	const openInfoModal = (record) => {
		setInfoRecord(record);
		setInfoModalOpen(true);
		loadModalData(record);
	};

	useEffect(() => {
		// The snapshot (if any) has already been read into `restoredFilterState`
		// for this mount, so clear it right away. From here on, the only thing
		// that can write it again is showMap() — i.e. navigating into the
		// details page. Any other route change (Dashboard, Alarms, Reports, ...)
		// leaves it null, so coming back to Realtime Detection from those
		// modules always starts with default filters.
		realtimedetection_filter_state = null;

		if(featuresModule.realtimeDetectionEnabled == false) {
			navigate('/dashboard');
		}
		window.scrollTo(0, 0);
		localStorage.setItem(dashboardtype.toUpperCase()+ '_ACTIVE_MENU_ITEM' , 1137);
	}, []);

	// ---- Region-driven lookups + map data (mirrors AlarmReport.jsx's first
	// useEffect — depends only on authtoken/region/allocation, not on any of
	// the drawer's filter values). ----
	useEffect(()=>{
		if(!authtoken){
			navigate('/');
		}
		else{
			if(admin_roles.includes(permission)){
				getPids(authtoken);
				getRegion(authtoken);
			}
			else{
				getUserAllocation(authtoken);
			}
			loadDetectionAlgorithm();
			loadCoordinate();
			if (map_type && map_type === 'leaflet') {
				handleGetMapdata(authtoken, regionId, null, null);
				handleOptionalPipelinedata(authtoken, pipelineId, regionId, null, null);
			}
		}
	},[authtoken, regionId, allocationId]);

	// ---- Cascading dropdown data (channels / chains) — these follow the
	// DRAFT pids/channel selection live, purely to populate the drawer's own
	// option lists, independent of whether "Apply" has been clicked. ----
	useEffect(() => {
		if(authtoken){
			if(pidsFilter!=null){
				getChannels(authtoken, pidsFilter);
			}
			loadMultiplemodels();
		}
	},[authtoken, pidsFilter, channelsdata]);

	// ---- Actual data fetch (list + map). Mirrors AlarmReport.jsx's
	// getAlarm/getMapAlarm useEffect: only fires on region/allocation change
	// or when the APPLIED filter state changes — i.e. only after "Apply" is
	// clicked in the filter drawer, never on a raw filter selection. ----
	useEffect(() => {
		if(authtoken){
			getRealtimedetectiondata(1);
			loadAsnData();
		}
	},[authtoken, regionId, allocationId, appliedPidsFilter, appliedChannelsdata, appliedChains, appliedAlgorithm, appliedTrajectory, appliedStartDate, appliedEndDate,view,appliedaisNameFilter]);

	let Realtimedetectiondata = [];

	realtimedetection_data.realtimedetection_data && realtimedetection_data.realtimedetection_data.map((item) => {
		const datetime = datetimeCovertertolocal(item.starttime ? item.starttime : null);
		const endtime = datetimeCovertertolocal(item.endtime ? item.endtime : null);
		Realtimedetectiondata.push({
			id: item?.id,
			channelName: item?.channelName ? item.channelName : '',
			eventPosition: item?.channelRange ? item.channelRange : [],
			channelRange: item?.channelRange ? item.channelRange : [],
			distanceRangeCoordinates: item?.distanceRangeCoordinates ? item.distanceRangeCoordinates : {},
			distanceRange: item?.distanceRange && item?.distanceRange !== null ? item.distanceRange : [],
			depthRange: item?.depthRange && item?.depthRange !== null ? item.depthRange : [],
			peakCoordinates: item?.peakCoordinates && item?.peakCoordinates !== null ? item.peakCoordinates : 'No Data',
			detectionAlgorithmTypeName: item?.detectionAlgorithmTypeName ? item.detectionAlgorithmTypeName : '',
			starttime: `${datetime.localdate} ${datetime.localtime}`,
			endtime: `${endtime.localdate} ${endtime.localtime}`,
			multipleModelName: item?.multipleModelName ? item.multipleModelName : '',
			eventType: item?.eventType ? item.eventType : '',
			pidsinfoId: item?.pidsinfoId ? item.pidsinfoId : '',
			detectionalgorithmtypeId: item?.detectionalgorithmtypeId ? item.detectionalgorithmtypeId : '',
			regioninfoId: item?.regioninfoId ? item.regioninfoId : '',
			channelId: item?.channelId ? item.channelId : '',
			multiplemodelsId: item?.multiplemodelsId ? item.multiplemodelsId : '',
			detectionResults: item?.detectionResults ? item.detectionResults : {},
			correctedDetectionResults: item?.correctedDetectionResults ? item.correctedDetectionResults : {},
			isTrajectoryProcessed: item?.isTrajectoryProcessed ? item.isTrajectoryProcessed : '',
			isTrajectoryCorrected: item?.isTrajectoryCorrected ? item.isTrajectoryCorrected : '',
			createdAt: item?.createdAt ? item.createdAt : '',
			updatedAt: item?.updatedAt ? item.updatedAt : '',
			pipelineId: item?.pipelineId ? item.pipelineId : '',
			regionName: item?.regionName ? item.regionName : '',
			hidden: item?.hidden ?? false,
			pidsName: item?.pidsName ? item.pidsName : '',
			peakDistance: item?.peakDistance &&  item?.peakDistance !== null ? item.peakDistance.toFixed(2) : 'No Data',
		});
	});

	// PERFORMANCE: ASNdata is memoized on the raw API response. Previously it
	// was rebuilt into a brand-new array on EVERY render of this component
	// (including every Play tick), which made SeaMap's asnTrajectories ->
	// asnItems -> <BulkLayer /> chain tear down and re-plot every AIS point
	// each time. Now it keeps the same reference until the AIS data changes.
	const ASNdata = useMemo(() => {
		const list = [];
		realtimedetection_data.asndata && realtimedetection_data.asndata.map((item) => {
			list.push({
				datetime: item?.datetime ? item.datetime : [],
				latitude: item?.latitude ? item.latitude : [],
				longitude: item?.longitude ? item.longitude : [],
				name: item?.name ? item.name : 'No Data',
				speed: item?.speed ? item.speed : [],
				
			});
		});
		return list;
	}, [realtimedetection_data.asndata]);

	let regions=[{value:null,
		label:`${langdata && langdata.ALL ? langdata.ALL:'ALL'}`
	}];

	if(admin_roles.includes(permission)){
		regiondata && regiondata.map((region)=>{
			regions.push({
				value:region.id,
				label:region.regionName.toUpperCase()});
		});
	} else {
		getUserAllocationData && getUserAllocationData.map((region)=>{
			regions.push({
				value:region.id,
				label: region.regioninfo.regionName+'(' + region.pipelineConfigFrom+' - '+region.pipelineConfigTo + ')',
				region: region.regioninfoId,
				pipelineConfigFrom : region.pipelineConfigFrom,
				pipelineConfigTo : region.pipelineConfigTo
			});
		});
	}

	// ---- Pipeline / Fiber / Border / Optional-path geometry, grouped by region (mirrors GMap.jsx / AlarmReport.jsx) ----
	// PERFORMANCE: memoized on mapdata / optionalpipedata so SeaMap receives
	// the SAME arrays between renders (new arrays every render defeated
	// React.memo on SeaMap and re-created every Polyline in the layers control).
	const { pipelineTracks, fiberTracks, pipelineBorderTracks, optionalPathTracks } = useMemo(() => {
		const tempMapArray = {};
		const teampOptionalMapArray = {};

		mapdata && mapdata.map((item) => {
			const fieldValue = item['regioninfoId'];
			if (!tempMapArray[fieldValue]) {
				tempMapArray[fieldValue] = [];
			}
			tempMapArray[fieldValue].push(item);
		});

		optionalpipedata && optionalpipedata.map((item) => {
			const fieldValue = item['regioninfoId'];
			if (!teampOptionalMapArray[fieldValue]) {
				teampOptionalMapArray[fieldValue] = [];
			}
			teampOptionalMapArray[fieldValue].push(item);
		});

		return {
			pipelineTracks: Object.values(tempMapArray).map((item) =>
				item.map((data) => [data.latitude, data.longitude])
			),
			fiberTracks: Object.values(tempMapArray).map((item) =>
				item.map((data) => [data.fibreLatitude, data.fibreLongitude])
			),
			pipelineBorderTracks: Object.values(tempMapArray).map((item) =>
				item.map((data) => [data.latitude, data.longitude])
			),
			optionalPathTracks: Object.values(teampOptionalMapArray).map((item) =>
				item.map((data) => [data.walkingLatitude, data.walkingLongitude])
			),
		};
	}, [mapdata, optionalpipedata]);

	// ============================================================
	// ROU MARKERS — KMP / WB / TP (Turn) / TLP / CH
	//
	// Ported 1:1 from RealtimeEvents.jsx (the OpenStreetMap/Leaflet
	// "Realtime Events" page). `mapdata` carries a `rouMarker` field on
	// each point ('CH' | 'WB' | 'TLP' | 'KMP' | 'TP'); this buckets them
	// into five arrays of { geocode, pop, landmarkDescription,
	// pipelineChainage } — the exact same shape RealtimeEvents.jsx builds
	// and feeds to its Leaflet <Marker> layers — so SeaMap.jsx can render
	// the identical layer-control checkboxes/markers on the OpenSeaMap
	// view.
	//
	// PERFORMANCE: now memoized on `mapdata` so the marker arrays keep the
	// same identity between renders (they used to be rebuilt every render).
	// ============================================================
	const { KMP, WB, Turn, TLP, CH } = useMemo(() => {
		const KMP = [];
		const WB = [];
		const Turn = [];
		const TLP = [];
		const CH = [];

		mapdata && mapdata.map((item) => {
			if (item.rouMarker == 'CH') {
				CH.push({
					geocode: [item.latitude, item.longitude],
					pop: `${langdata && langdata.CH ? langdata.CH : 'CH'}`,
					landmarkDescription: item?.landmarkDescription,
					pipelineChainage: item?.pipelineChainage !== null && item?.pipelineChainage !== undefined ? item.pipelineChainage : null,
					ODMeter: item?.ODMeter !== null && item?.ODMeter !== undefined ? item.ODMeter : null,
				});
			}
			else if (item.rouMarker == 'WB') {
				WB.push({
					geocode: [item.latitude, item.longitude],
					pop: `${langdata && langdata.WB ? langdata.WB : 'WB'}`,
					landmarkDescription: item?.landmarkDescription,
					pipelineChainage: item?.pipelineChainage,
					ODMeter: item?.ODMeter,
				});
			}
			else if (item.rouMarker == 'TLP') {
				TLP.push({
					geocode: [item.latitude, item.longitude],
					pop: `${langdata && langdata.TLP ? langdata.TLP : 'TLP'}`,
					landmarkDescription: item?.landmarkDescription,
					pipelineChainage: item?.pipelineChainage,
					ODMeter: item?.ODMeter,
				});
			}
			else if (item.rouMarker == 'KMP') {
				KMP.push({
					geocode: [item.latitude, item.longitude],
					pop: `${langdata && langdata.KMP ? langdata.KMP : 'KMP'}`,
					landmarkDescription: item?.landmarkDescription,
					pipelineChainage: item?.pipelineChainage != null ? item.pipelineChainage : null,
					ODMeter: item?.ODMeter !== null && item?.ODMeter !== undefined ? item.ODMeter : null,
				});
			}
			else if (item.rouMarker == 'TP') {
				Turn.push({
					geocode: [item.latitude, item.longitude],
					pop: `${langdata && langdata.TP ? langdata.TP : 'TP'}`,
					landmarkDescription: item?.landmarkDescription,
					pipelineChainage: item?.pipelineChainage,
					ODMeter: item?.ODMeter,
				});
			}
		});

		return { KMP, WB, Turn, TLP, CH };
	}, [mapdata, langdata]);

	// ============================================================
	// Detection trajectories for the map view (SeaMap) — one per currently
	// loaded detection.
	//
	// IMPORTANT: this is memoized on the raw API response
	// (`realtimedetection_data.realtimedetection_data`) and the trajectory
	// method flag (`trajectory`) only, so it keeps the exact SAME array/
	// object references across re-renders that don't actually change the
	// underlying data — this is what makes the Play animation below
	// reproducible: it always starts from the exact same, deterministic
	// snapshot of points every time.
	//
	// `detectionAlgorithmTypeId` is now included on every trajectory —
	// SeaMap is the single authority for turning that ID into a color
	// (via its own colorForAlgorithmId), so a trajectory's points and its
	// own polyline are guaranteed to match, and the same algorithm ID
	// always renders in the same color everywhere.
	//
	// `portPoints` — built from result.portLatitude / result.portLongitude,
	// index-aligned with the source arrays. SeaMap plots these exactly like
	// the source points (same color / hover), but with a DOTTED line. If a
	// detection has no portLatitude/portLongitude, `portPoints` is [] and
	// nothing is plotted for it.
	// ============================================================
	const detectionTrajectories = useMemo(() => {
		const trajectories = [];

		const rawData = realtimedetection_data.realtimedetection_data || [];

		rawData.forEach((item) => {
			if (!item?.isTrajectoryProcessed) return;

			const result = trajectory ? item.correctedDetectionResults : item.detectionResults;
			if (!result) return;

			const latitudes = result?.sourceLatitude || [];
			const longitudes = result?.sourceLongitude || [];
			const portLatitude = result?.portLatitude || [];
			const portLongitude = result?.portLongitude || [];
			const sourceDistances = result?.sourceDistances || [];
			const sourceAngles = result?.sourceAngle || [];
			const sbr = result?.sbr || [];
			const startTimeHover = result?.timeStart || [];

			if (!latitudes.length || !longitudes.length) return;

			let cpaIndex = -1;
			if (result?.cpaSourceDistance != null) {
				let smallestDifference = Infinity;
				sourceDistances.forEach((distance, index) => {
					const difference = Math.abs(Number(distance) - Number(result.cpaSourceDistance));
					if (difference < smallestDifference) {
						smallestDifference = difference;
						cpaIndex = index;
					}
				});
			}

			// Points are kept in their ORIGINAL order (index 0 = the true
			// starting point, last index = the true end point). isCPA is
			// just a flag on one of these points — it never reorders the
			// array. This original order is exactly what the Play
			// animation below walks through, in the same order, every
			// single time.
			const points = latitudes
				.map((latitude, index) => {
					const longitude = longitudes[index];
					if (
						latitude == null || longitude == null ||
						!Number.isFinite(Number(latitude)) || !Number.isFinite(Number(longitude))
					) {
						return null;
					}
					return {
						lat: Number(latitude),
						lng: Number(longitude),
						sourceAngle: sourceAngles[index],
						sbr: sbr[index],
						isCPA: index === cpaIndex,
					};
				})
				.filter(Boolean);

			if (points.length === 0) return;

			// Port points: same index alignment as the source arrays, so the
			// hover info (distance / speed / time) can be looked up by the
			// ORIGINAL index (`index`). Empty array when there is no
			// portLatitude/portLongitude -> SeaMap plots nothing for it.
			const portPoints = portLatitude
				.map((latitude, index) => {
					const longitude = portLongitude[index];
					if (
						latitude == null || longitude == null ||
						!Number.isFinite(Number(latitude)) || !Number.isFinite(Number(longitude))
					) {
						return null;
					}
					return {
						lat: Number(latitude),
						lng: Number(longitude),
						sourceAngle: sourceAngles[index],
						sbr: sbr[index],
						index,
					};
				})
				.filter(Boolean);

			const detectionalgorithmtypeId = item?.detectionalgorithmtypeId ? item.detectionalgorithmtypeId : '';

			trajectories.push({
				id: item?.id,
				detectionAlgorithmTypeId: detectionalgorithmtypeId,
				color: colorForAlgorithmId(detectionalgorithmtypeId),
				label: item?.channelName ? item.channelName : '',
				algorithmName: item?.detectionAlgorithmTypeName ? item.detectionAlgorithmTypeName : '',
				modelName: item?.multipleModelName ? item.multipleModelName : '',
				eventType: item?.eventType ? item.eventType : '',
				pidsName: item?.pidsName ? item.pidsName : '',
				channelName: item?.channelName ? item.channelName : '',
				sourceSpeedKts: result.sourceSpeedKts,
				peakDistance: item?.peakDistance && item?.peakDistance !== null ? item.peakDistance : null,
				peakCoordinates: item?.peakCoordinates && item?.peakCoordinates !== null ? item.peakCoordinates : null,
				cpaSourceDistance: sourceDistances,
				points,
				portPoints,
				startTimeHover : startTimeHover ? startTimeHover : []
			});
		});

		return trajectories;
	}, [realtimedetection_data.realtimedetection_data, trajectory]);

	// ============================================================
	// DISTANCE RANGE TRACKS (map view)
	//
	// For every loaded detection, takes the min / max of its
	// `distanceRange` array (fibre distance in metres) and slices the
	// fibre polyline (mapdata fibreLatitude / fibreLongitude, ordered by
	// ODMeter) between those two distances. SeaMap draws each slice as a
	// wide, transparent band (same style as "System Border") in the
	// detection's algorithm color, so the detected range is visible
	// directly on the fibre.
	// ============================================================
	// ============================================================
	// DISTANCE RANGE TRACKS (map view)
	//
	// The fibre polyline is taken in the SAME order it is drawn
	// (mapdata order, like fiberTracks), so the band always follows the
	// fibre. Every fibre point gets a distance: its own ODMeter when
	// present, otherwise interpolated from neighbouring ODMeter values
	// by geometric distance along the line. For each detection the
	// min / max of `distanceRange` are located exactly on that line
	// (interpolated inside a segment) and only the fibre between them is
	// returned, so nothing can jump off the fibre.
	// ============================================================
	// ============================================================
	// DISTANCE RANGE TRACKS (map view)
	//
	// `distanceRange` = [start, end] (fibre distance in metres). The
	// range is located on the fibre line and only the part of the line
	// between start and end is returned, so SeaMap can draw it as a wide
	// transparent band (same style as "System Border") in the
	// detection's algorithm color.
	// ============================================================
	const distanceRangeTracks = useMemo(() => {
		const rawData = realtimedetection_data.realtimedetection_data || [];
		if (!mapdata || mapdata.length === 0 || rawData.length === 0) return [];

		const toNum = (v) =>
			v === null || v === undefined || v === '' ? NaN : Number(v);
		const toRad = (deg) => (deg * Math.PI) / 180;
		const haversineMeters = (a, b) => {
			const R = 6371000;
			const dLat = toRad(b.lat - a.lat);
			const dLng = toRad(b.lng - a.lng);
			const h =
				Math.sin(dLat / 2) ** 2 +
				Math.cos(toRad(a.lat)) * Math.cos(toRad(b.lat)) * Math.sin(dLng / 2) ** 2;
			return 2 * R * Math.asin(Math.min(1, Math.sqrt(h)));
		};

		// Channel id helper — change the field names here if your mapdata differs.
		const getChannelId = (obj) => {
			const c = obj?.channelId ?? obj?.channelinfoId ?? null;
			return c === null || c === undefined || c === '' ? null : c;
		};

		// 1) Line points grouped by region AND by region+channel, in drawn order.
		//    Fibre coordinates are preferred; pipeline coordinates are the fallback.
		//    Each point goes into its region bucket (`<region>`) and, when it
		//    carries a channel id, also into a channel bucket (`<region>|<channel>`).
		const rawByRegion = {};
		mapdata.forEach((point) => {
			// FIBRE ONLY: the line is built strictly from the fibre coordinates
			// (same fields as the "Fiber" layer / fiberTracks). No pipeline fallback.
			const lat = toNum(point?.fibreLatitude);
			const lng = toNum(point?.fibreLongitude);
			if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;

			const od = toNum(point?.ODMeter);
			const regionKey = point?.regioninfoId ?? 'all';
			const channelId = getChannelId(point);
			const entry = { lat, lng, od: Number.isFinite(od) ? od : null };

			if (!rawByRegion[regionKey]) rawByRegion[regionKey] = [];
			rawByRegion[regionKey].push(entry);

			if (channelId !== null) {
				const channelKey = `${regionKey}|${channelId}`;
				if (!rawByRegion[channelKey]) rawByRegion[channelKey] = [];
				rawByRegion[channelKey].push({ ...entry });
			}
		});

		// 2) Give every point a distance along the line.
		const buildLine = (pts, cum, useOd) => {
			const knownIdx = [];
			pts.forEach((p, i) => { if (p.od !== null) knownIdx.push(i); });

			const dist = pts.map((p, i) => {
				if (!useOd || knownIdx.length < 2) return cum[i];
				if (p.od !== null) return p.od;

				let prev = -1;
				let next = -1;
				for (let k = 0; k < knownIdx.length; k += 1) {
					if (knownIdx[k] < i) prev = knownIdx[k];
					if (knownIdx[k] > i) { next = knownIdx[k]; break; }
				}
				if (prev !== -1 && next !== -1) {
					const span = cum[next] - cum[prev];
					const ratio = span > 0 ? (cum[i] - cum[prev]) / span : 0;
					return pts[prev].od + (pts[next].od - pts[prev].od) * ratio;
				}
				if (prev !== -1) return pts[prev].od + (cum[i] - cum[prev]);
				return pts[next].od - (cum[next] - cum[i]);
			});

			let line = pts.map((p, i) => ({ lat: p.lat, lng: p.lng, od: dist[i] }));
			if (line[0].od > line[line.length - 1].od) line = line.reverse();
			return line;
		};

		const lineByRegion = {};
		Object.keys(rawByRegion).forEach((key) => {
			const pts = rawByRegion[key];
			if (pts.length < 2) return;

			const cum = [0];
			for (let i = 1; i < pts.length; i += 1) {
				cum.push(cum[i - 1] + haversineMeters(pts[i - 1], pts[i]));
			}

			// Use ODMeter if it increases along the line, else geometric length.
			let line = buildLine(pts, cum, true);
			const usable =
				line[line.length - 1].od > line[0].od &&
				line.every((p, i) => i === 0 || p.od >= line[i - 1].od - 1e-6);
			if (!usable) line = buildLine(pts, cum, false);

			lineByRegion[key] = line;
		});

		// 3) Exact position on the line for a given distance.
		const pointAtDistance = (line, distance) => {
			if (distance <= line[0].od) {
				return { lat: line[0].lat, lng: line[0].lng, od: line[0].od, next: 1 };
			}
			const last = line[line.length - 1];
			if (distance >= last.od) {
				return { lat: last.lat, lng: last.lng, od: last.od, next: line.length };
			}
			for (let i = 0; i < line.length - 1; i += 1) {
				const a = line[i];
				const b = line[i + 1];
				if (distance >= a.od && distance <= b.od) {
					const span = b.od - a.od;
					const ratio = span > 0 ? (distance - a.od) / span : 0;
					return {
						lat: a.lat + (b.lat - a.lat) * ratio,
						lng: a.lng + (b.lng - a.lng) * ratio,
						od: distance,
						next: i + 1,
					};
				}
			}
			return { lat: last.lat, lng: last.lng, od: last.od, next: line.length };
		};

		// 4) distanceRange -> [[min, max], ...]. Normally one pair ([start, end]).
		const getFragments = (rawRange) => {
			let range = rawRange;
			if (typeof range === 'string') {
				try { range = JSON.parse(range); } catch (e) { range = []; }
			}
			if (!Array.isArray(range)) return [];

			const nums = range.flat().map(toNum).filter(Number.isFinite);
			const fragments = [];
			for (let i = 0; i + 1 < nums.length; i += 2) {
				fragments.push([Math.min(nums[i], nums[i + 1]), Math.max(nums[i], nums[i + 1])]);
			}
			return fragments;
		};

		const tracks = [];

		rawData.forEach((item) => {
			const fragments = getFragments(item?.distanceRange);
			if (fragments.length === 0) return;

			const regionKey = item?.regioninfoId ?? 'all';
			const itemChannelId = getChannelId(item);

			// Prefer the detection's own channel line, then the region line.
			const line =
	(itemChannelId !== null && lineByRegion[`${regionKey}|${itemChannelId}`]) ||
	lineByRegion[regionKey] ||
	lineByRegion.all ||
	Object.values(lineByRegion)[0];
			if (!line || line.length < 2) return;

			const color = colorForAlgorithmId(
				item?.detectionalgorithmtypeId ? item.detectionalgorithmtypeId : ''
			);

			fragments.forEach(([fragMin, fragMax], fragIndex) => {
				if (fragMin === fragMax) return;

				const start = pointAtDistance(line, fragMin);
				const end = pointAtDistance(line, fragMax);
				if (start.od === end.od) return; // completely outside the line

				// start, every line vertex strictly between them, end.
				const positions = [[start.lat, start.lng]];
				for (let k = start.next; k < end.next; k += 1) {
					if (line[k] && line[k].od > start.od && line[k].od < end.od) {
						positions.push([line[k].lat, line[k].lng]);
					}
				}
				positions.push([end.lat, end.lng]);
				if (positions.length < 2) return;

				tracks.push({
					id: `${item?.id}-${item?.channelId ?? 'na'}-${fragIndex}`,
					channelId: item?.channelId ?? null,
					color,
					algorithmName: item?.detectionAlgorithmTypeName ? item.detectionAlgorithmTypeName : '',
					channelName: item?.channelName ? item.channelName : '',
					eventType: item?.eventType ? item.eventType : '',
					minDistance: fragMin,
					maxDistance: fragMax,
					positions,
					startPoint: { lat: start.lat, lng: start.lng, distance: fragMin },
					endPoint: { lat: end.lat, lng: end.lng, distance: fragMax },
				});
			});
		});
		// console.log('distanceRangeTracks', tracks.length, rawData.slice(0, 3).map(d => d.distanceRange), Object.keys(lineByRegion));

		return tracks;
	}, [realtimedetection_data.realtimedetection_data, mapdata]);

	// ============================================================
	// CUSTOM "PLAY" ANIMATION — ported from RealtimeDetectionDetails.jsx.
	// Unlike SeaMap's own built-in trajectory PLAY (disabled here via
	// showTrajectoryPlayControl={false}), this reveals EVERY plotted point
	// of EVERY currently-loaded trajectory, one index at a time, in
	// PARALLEL, always starting from index 0 (each trajectory's true
	// starting point, in original order) and running through the full
	// length of the longest trajectory currently loaded — so every
	// trajectory plays its own points, IN ORDER, from its own start point
	// to its own end point, and stops there.
	//
	// PORT TRAIL: the port points of every trajectory are revealed in the
	// same ticks as the source points (same index, same 500ms cadence), so
	// both trails animate together. The port trail is drawn dotted.
	//
	// NOTE: Play intentionally does NOT move or zoom the map anymore — it
	// only reveals the trail/marker in place. If you're zoomed in on a
	// spot, starting Play keeps that exact view instead of zooming out to
	// fit every trajectory (which is what used to happen).
	//
	// `playSessionRef` holds a single object identifying the CURRENT Play
	// run. The interval below only ever applies a tick if it is still the
	// session `playSessionRef.current` points at. This makes it
	// impossible for a stale/leftover interval (e.g. from an effect
	// re-invocation) to write into state after a newer session has
	// started or Play has been switched off — which is what could
	// previously cause points to be skipped, or the animation to look
	// different on every click, even though the underlying point order
	// was always correct.
	// ============================================================

	const [changePlayrealtimedetectionLine, setChangePlayrealtimedetectionLine] = useState(false);
	const [playTrajectoryLines, setPlayTrajectoryLines] = useState({});
	const [playPortTrajectoryLines, setPlayPortTrajectoryLines] = useState({});
	const playSessionRef = useRef(null);

	const runPlayLogic = () => {
		setChangePlayrealtimedetectionLine(true);
	};

	const stopPlayLogic = () => {
		setChangePlayrealtimedetectionLine(false);
	};

	useEffect(() => {
		// Always tear down whatever session is currently running first, no
		// matter why this effect is executing (Play switched off, or the
		// underlying trajectories changed while Play was on).
		if (playSessionRef.current) {
			clearInterval(playSessionRef.current.timer);
			playSessionRef.current = null;
		}

		if (!changePlayrealtimedetectionLine) {
			setPlayTrajectoryLines({});
			setPlayPortTrajectoryLines({});
			return undefined;
		}

		// Build ONE deterministic snapshot of every trajectory's full,
		// in-order source AND port point lists the moment Play starts.
		// Every tick below only ever reads from these same snapshots.
		const fullLines = {};
		const fullPortLines = {};
		let maxLength = 0;

		detectionTrajectories.forEach((traj) => {
			const points = (traj.points || [])
				.filter((point) => point && point.lat != null && point.lng != null)
				.map((point) => [point.lat, point.lng]);
			fullLines[traj.id] = points;
			if (points.length > maxLength) {
				maxLength = points.length;
			}

			const portPts = (traj.portPoints || [])
				.filter((point) => point && point.lat != null && point.lng != null)
				.map((point) => [point.lat, point.lng]);
			fullPortLines[traj.id] = portPts;
			if (portPts.length > maxLength) {
				maxLength = portPts.length;
			}
		});

		setPlayTrajectoryLines({});
		setPlayPortTrajectoryLines({});

		if (maxLength === 0) {
			return undefined;
		}

		const session = { fullLines, fullPortLines, maxLength, index: 0, timer: null };
		playSessionRef.current = session;

		session.timer = setInterval(() => {
			// If a newer session has since replaced this one, or Play was
			// turned off, this stale tick must do nothing.
			if (playSessionRef.current !== session) {
				clearInterval(session.timer);
				return;
			}

			if (session.index >= session.maxLength) {
				clearInterval(session.timer);
				return;
			}

			const currentIndex = session.index;

			setPlayTrajectoryLines((prev) => {
				const next = { ...prev };
				Object.keys(session.fullLines).forEach((id) => {
					const point = session.fullLines[id][currentIndex];
					if (point) {
						next[id] = [...(next[id] || []), point];
					}
				});
				return next;
			});

			setPlayPortTrajectoryLines((prev) => {
				const next = { ...prev };
				Object.keys(session.fullPortLines).forEach((id) => {
					const point = session.fullPortLines[id][currentIndex];
					if (point) {
						next[id] = [...(next[id] || []), point];
					}
				});
				return next;
			});

			session.index += 1;
		}, 500);

		return () => {
			if (playSessionRef.current === session) {
				clearInterval(session.timer);
				playSessionRef.current = null;
			}
		};
	}, [changePlayrealtimedetectionLine, detectionTrajectories]);

	// The PLAY entry in the layers control — an invisible Polyline whose
	// add/remove events (fired when the checkbox is toggled) drive
	// runPlayLogic/stopPlayLogic, exactly like RealtimeDetectionDetails.jsx.
	//
	// PERFORMANCE: memoized (the handlers only call state setters, which are
	// stable) so SeaMap doesn't get a new element on every parent render.
	const pipelineLayersControlChildren = useMemo(() => (
		<LayersControl.Overlay name={langdata && langdata.Play ? langdata.Play : 'Play'}>
			<Polyline
				positions={[]}
				eventHandlers={{
					add: () => { runPlayLogic(); },
					remove: () => { stopPlayLogic(); }
				}}
			/>
		</LayersControl.Overlay>
	), [langdata]);

	// The moving trail + ship icon for every trajectory currently animating
	// (source trail = solid green, port trail = dotted green).
	// No camera-follower here anymore — the map view is left exactly as the
	// user has it when Play starts.
	//
	// PERFORMANCE: memoized — only changes while Play is actually ticking.
	const realtimeDetectionPlayMapChildren = useMemo(() => (changePlayrealtimedetectionLine ? (
		<>
			{detectionTrajectories.map((trajectory_) => {
				const points = playTrajectoryLines[trajectory_.id];
				const portPts = playPortTrajectoryLines[trajectory_.id];
				const hasSource = points && points.length > 0;
				const hasPort = portPts && portPts.length > 0;

				if (!hasSource && !hasPort) {
					return null;
				}

				const head = hasSource ? points[points.length - 1] : null;
				const portHead = hasPort ? portPts[portPts.length - 1] : null;
				const popupLabel =
					trajectory_.channelName || trajectory_.label ||
					(langdata && langdata.RealtimeDetection ? langdata.RealtimeDetection : 'Detection');

				return (
					<React.Fragment key={`play-trajectory-${trajectory_.id}`}>
						{hasSource && (
							<>
								<Polyline
									pathOptions={linecolor}
									weight={7}
									positions={points}
								/>
								<Marker position={{ lat: head[0], lng: head[1] }} icon={vesselCpaIcon}>
									<Popup>
										{popupLabel}
									</Popup>
								</Marker>
							</>
						)}

						{hasPort && (
							<>
								<Polyline
									pathOptions={portLinecolor}
									weight={7}
									positions={portPts}
								/>
								<Marker position={{ lat: portHead[0], lng: portHead[1] }} icon={vesselCpaIcon}>
									<Popup>
										{popupLabel}
									</Popup>
								</Marker>
							</>
						)}
					</React.Fragment>
				);
			})}
		</>
	) : null), [changePlayrealtimedetectionLine, detectionTrajectories, playTrajectoryLines, playPortTrajectoryLines, langdata]);

	// Ids whose static CPA icon should stay hidden while PLAY is running —
	// reappears automatically the instant PLAY is switched off.
	//
	// PERFORMANCE: memoized so it doesn't create a new array every render.
	const hiddenTrajectoryCpaIds = useMemo(() => (
		changePlayrealtimedetectionLine
			? detectionTrajectories.map((trajectory_) => trajectory_.id)
			: EMPTY_ARRAY
	), [changePlayrealtimedetectionLine, detectionTrajectories]);

	// ---- Info modal handlers ----
	

	const closeInfoModal = () => {
		setInfoModalOpen(false);
		setInfoRecord(null);
	};
		
	// ---- Navigate into a detection's details page.
	//
	// This is the ONLY place the module-level filter snapshot is written.
	// Because it happens right before navigating to
	// `/realtimedetection-details`, the snapshot exists exclusively for that
	// round-trip: the next mount of this component reads it (see
	// `restoredFilterState` at the top) and immediately clears it again, so it
	// can never be picked up by a visit that came from a different module.
	const showMap = (realtimedetection) => {
		realtimedetection_filter_state = {
			view,
			regionId,
			allocationId,
			pidsFilter,
			channelsdata,
			chains,
			algorithm,
			trajectory,
			timeSelection,
			filterLastHour,
			advDateRange,
			startTime,
			endTime,
			appliedPidsFilter,
			appliedChannelsdata,
			appliedChains,
			appliedAlgorithm,
			appliedTrajectory,
			appliedStartDate,
			appliedEndDate,
		};

		navigate(( '/realtimedetection-details'),{ state: { data: realtimedetection, path: 'realtimedetections',trajectoryboolean: trajectory,KMP: KMP,CH: CH,asnData: ASNdata } });
	};
	const showSpectrogram = (realtimedetection) => {

		navigate(( '/spectrogram'),{ state: { data: realtimedetection, path: 'realtimedetections', } });
	};



	const getRealtimedetectiondata = (pagination) => {
		let _pagination = { };
		_pagination.total = realtimedetection_data_pagination.total ? realtimedetection_data_pagination.total : 0;
		_pagination.limit = pagination.pageSize ? pagination.pageSize : 10;
		_pagination.skip =  pagination && pagination.current ? parseInt((pagination.current-1) * pagination.pageSize) : 0;

		dispatch({ type : REALTIME_DETECTION_LIST});

		const body ={};

		if(appliedPidsFilter){
			body.pidsinfoId = appliedPidsFilter;
		}
		if(regionId){
			body.regionId = regionId;
		}
		if(appliedChannelsdata){
			body.channelId = appliedChannelsdata;
		}
		if(appliedChains){
			body.multiplemodelsId = appliedChains;
		}
		if(appliedAlgorithm!=null){
			body.detectionalgorithmtypeId = appliedAlgorithm;
		}
		if(appliedTrajectory!=null){
			body.isTrajectoryCorrected = appliedTrajectory;
		}
		if(appliedStartDate){
			body.gteCreatedAt = appliedStartDate;
		}
		if(appliedEndDate){
			body.lteCreatedAt = appliedEndDate;
		}

		let apiUrl = `${api}/realtimedetectionexclude`;

		if(view === 'List'){
			apiUrl += `?limit=${_pagination.limit}&skip=${_pagination.skip}`;
		}

		let config = {
			method: 'post',
			maxBodyLength: Infinity,
			url: apiUrl,
			timeout: timeout,
			headers: { 
				'Content-Type': 'application/json', 
				'Authorization': `Bearer ${authtoken}`
			},
			data : body
		};
      
		axios.request(config)
			.then((response) => {
				if (response.status === 200) {
					realtimedetection_data_pagination.total = response.data.total ? response.data.total : 0;
					realtimedetection_data_pagination.limit = response.data.limit ? response.data.limit : 10;
					realtimedetection_data_pagination.skip = response.data.skip ? response.data.skip : 0;
					realtimedetection_data_pagination.current = pagination.current ? pagination.current : 1;
					dispatch({ type : REALTIME_DETECTION_LIST_SUCCESS, payload : response.data, page:pagination.current, pageSize : pagination.pageSize });
					// loadDetectionAlgorithm();
					// loadCoordinate();
				}else {
					dispatch({ type : REALTIME_DETECTION_LIST_ERROR});
				}
			})
			.catch((error) => {
				console.log(error);

				dispatch({ type: REALTIME_DETECTION_LIST_ERROR });

				message.config({
					duration: 5,
					maxCount: 1,
				});

				if (error.code === 'ECONNABORTED' || error.code === 'ERR_NETWORK') {
					message.open({
						type: 'error',
						content: `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication
							? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication
							: 'It seems the network is unreachable. Please refresh the application.'}`,
					});
				} else {
					message.open({
						type: 'error',
						content: error?.response?.data?.message
							? error.response.data.message
							: 'Something went wrong. Please try again.',
					});
				}
			});
	};


	const getRealtimedetectionPatchData = () => {
		// let _pagination = { };
		// _pagination.total = realtimedetection_data_pagination.total ? realtimedetection_data_pagination.total : 0;
		// _pagination.limit = pagination.pageSize ? pagination.pageSize : 10;
		// _pagination.skip =  pagination && pagination.current ? parseInt((pagination.current-1) * pagination.pageSize) : 0;
		const record = realtimedetection_data.details;

		dispatch({ type : UPDATE_REALTIME_DETECTION_LIST});

		const body ={};
		let id = '';

		if(record.id){
			id = record.id;
		}
		if(record.pidsinfoId){
			body.pidsinfoId = record.pidsinfoId;
		}
		
		body.hidden = true;
		
		// if(regionId){
		// 	body.regionId = regionId;
		// }
		// if(appliedChannelsdata){
		// 	body.channelId = appliedChannelsdata;
		// }
		// if(appliedChains){
		// 	body.multiplemodelsId = appliedChains;
		// }
		// if(appliedAlgorithm!=null){
		// 	body.detectionalgorithmtypeId = appliedAlgorithm;
		// }
		// if(appliedTrajectory!=null){
		// 	body.isTrajectoryCorrected = appliedTrajectory;
		// }
		// if(appliedStartDate){
		// 	body.gteCreatedAt = appliedStartDate;
		// }
		// if(appliedEndDate){
		// 	body.lteCreatedAt = appliedEndDate;
		// }

		let config = {
			method: 'patch',
			maxBodyLength: Infinity,
			url: `${api}/realtimedetection/${id}`,
			timeout: timeout,
			headers: { 
				'Content-Type': 'application/json', 
				'Authorization': `Bearer ${authtoken}`
			},
			data : body
		};
      
		axios.request(config)
			.then((response) => {
				if (response.status === 200) {
					realtimedetection_data_pagination.total = response.data.total ? response.data.total : 0;
					realtimedetection_data_pagination.limit = response.data.limit ? response.data.limit : 10;
					realtimedetection_data_pagination.skip = response.data.skip ? response.data.skip : 0;
					// realtimedetection_data_pagination.current = pagination.current ? pagination.current : 1;
					dispatch({ type : UPDATE_REALTIME_DETECTION_LIST_SUCCESS, payload : response.data.data,});
					// loadDetectionAlgorithm();
					// loadCoordinate();
					message.success({
						content: `${langdata && langdata.Detectionhiddensuccessfully
							? langdata.Detectionhiddensuccessfully
							: 'Detection hidden successfully'}`,
					});
					setModalOpen(false);
					getRealtimedetectiondata(1);
				}else {
					dispatch({ type : UPDATE_REALTIME_DETECTION_LIST_ERROR});
				}
			})
			.catch((error) => {
				console.log(error);

				dispatch({ type: UPDATE_REALTIME_DETECTION_LIST_ERROR });

				message.config({
					duration: 5,
					maxCount: 1,
				});

				if (error.code === 'ECONNABORTED' || error.code === 'ERR_NETWORK') {
					message.open({
						type: 'error',
						content: `${langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication
							? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication
							: 'It seems the network is unreachable. Please refresh the application.'}`,
					});
				} else {
					message.open({
						type: 'error',
						content: error?.response?.data?.message
							? error.response.data.message
							: 'Something went wrong. Please try again.',
					});
				}
			});
	};

	const openShowAttachments = (record) => {
		
		setModalOpen(true);
		loadRealtimeDetectiondetails(record);

	};


	const loadRealtimeDetectiondetails = ((record) => {
    
		dispatch({ type: UPDATE_REALTIME_DETECTION_LIST_DETAILS });
        
		if (!record) {
			dispatch({ type: UPDATE_REALTIME_DETECTION_LIST_DETAILS_ERROR });
		} else {
			dispatch({
				type: UPDATE_REALTIME_DETECTION_LIST_DETAILS_SUCCESS,
				payload: record
			});
		}
    
	});

	const loadMultiplemodels = () => {
		let pidsort = '';
		let params = '';

		if(pidsFilter){
			pidsort = `&pidsinfoId=${pidsFilter}`;
		}


		if(channelsdata){
			params = params + `&channelinfoId=${channelsdata}`;
		}
	
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/multiplemodels/?pipelineId=${parseInt(pipelineId)}&$sort[id]=-1${pidsort}${params}`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization:`Bearer ${authtoken}`
			}
		}; 
		axios
			.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({type:MULTIPLEMODEL_LIST_SUCCESS, payload: response.data});
				}
			})
			.catch((error) => {
				dispatch({type:MULTIPLEMODEL_LIST_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}else{
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  `${langdata && langdata.SomethingWentWrong ? langdata.SomethingWentWrong :'Something Went Wrong!'}`,
					});
				}
			});
	};

	const loadAsnData = () => {
		// let pidsort = '';
		let startTime = '';
		let endTime = '';
		let aisName = '';

		const { start, end } = computeDateRange();

		if (appliedaisNameFilter && appliedaisNameFilter.length > 0) {
			// ALL selected → don't send vessel filter
			if (!appliedaisNameFilter.includes(null)) {
				appliedaisNameFilter.forEach((vessel) => {
					aisName += `&name[$in][]=${encodeURIComponent(vessel)}`;
				});
			}
		}

		// if(pidsFilter){
		// 	pidsort = `&pidsinfoId=${pidsFilter}`;
		// }

		if(start){
			startTime = `&datetime[$gte]=${dayjs(start).toISOString()}`;
		}
		if(end){
			endTime = `&datetime[$lte]=${dayjs(end).toISOString()}`;
		}


		// if(channelsdata){
		// 	params = params + `&channelinfoId=${channelsdata}`;
		// }
	
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/aisdata?isMapView=true${startTime}${endTime}${aisName}`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization:`Bearer ${authtoken}`
			}
		}; 
		axios
			.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({type:ASN_DATA_LIST_SUCCESS, payload: response.data});
				}
			})
			.catch((error) => {
				dispatch({type:ASN_DATA_LIST_ERROR});
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				}else{
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content:  `${langdata && langdata.SomethingWentWrong ? langdata.SomethingWentWrong :'Something Went Wrong!'}`,
					});
				}
			});
	};

	const getAISNameFilter = () => {
	
		dispatch({ type: AIS_NAME_FILTER });
	
		// let pidsort = '';
		let startTime = '';
		let endTime = '';
		// let aisName = '';
		
		const { start, end } = computeDateRange();
		
		// if(pidsFilter){
		// 	pidsort = `&pidsinfoId=${pidsFilter}`;
		// }
		
		if(start){
			startTime = `&datetime[$gte]=${dayjs(start).toISOString()}`;
		}
		if(end){
			endTime = `&datetime[$lte]=${dayjs(end).toISOString()}`;
		}
		// if(appliedaisNameFilter.length > 0){
		// 	aisName = `&name=${appliedaisNameFilter}`;
		// }
		
		
		// if(channelsdata){
		// 	params = params + `&channelinfoId=${channelsdata}`;
		// }
			
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/aisdata?isMapView=true${startTime}${endTime}`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization:`Bearer ${authtoken}`
			}
		}; 
	
		axios.request(config)
			.then((response) => {
				if (response.status === 200) {
	
					const aisdata = response.data.data.map((item) => ({
						name: item.name ? item.name : 'No Data',
					}));
	
					dispatch({
						type: AIS_NAME_FILTER_SUCCESS,
						payload: aisdata
					});
	
				} else {
					dispatch({
						type: AIS_NAME_FILTER_ERROR
					});
				}
			})
			.catch((error) => {
				console.log(error);
	
				dispatch({
					type: AIS_NAME_FILTER_ERROR
				});
	
				message.config({
					duration: 5,
					maxCount: 1,
				});
	
				if (error.code === 'ECONNABORTED' || error.code === 'ERR_NETWORK') {
					message.open({
						type: 'error',
						content: `${
							langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication
								? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication
								: 'It seems the network is unreachable. Please refresh the application.'
						}`,
					});
				} else {
					message.open({
						type: 'error',
						content: error?.response?.data?.message
							? error.response.data.message
							: 'Something went wrong. Please try again.',
					});
				}
			});
	};


	const loadDetectionAlgorithm = ()=>{    
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/detectionalgorithmtype?pipelineId=${pipelineId}&$sort[id]=1`,
			timeout: timeout,
			headers: { 
				'Content-Type': 'application/json', 
				Authorization:`Bearer ${authtoken}`				
			},
		};
		dispatch({type : DETECTION_ALGORITHM_LIST});
		axios.request(config)
			.then((response) => {
				if(response.status == 200 || response.status == 201){	
											
					dispatch({ type : DETECTION_ALGORITHM_LIST_SUCCESS, payload: response.data.data });
				} else {
					dispatch({ type : DETECTION_ALGORITHM_LIST_ERROR});			
				}
			})
			.catch((error) => {
				console.log(error);
				dispatch({ type : DETECTION_ALGORITHM_LIST_ERROR });
				if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration : 5,
						maxCount : 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
					});
				} else {
					// Modal.warning({ title: langdata && langdata.Unabletoupdatealgorithm ? langdata.Unabletoupdatealgorithm : 'Unable to update algorithm.' });											
				}
			});
	};

	const handleSetregion = (e,options) =>{
		localStorage.setItem(`${dashboardtype}_REGION_ID`,e);
		if(admin_roles.includes(permission)) {
			setRegionId(e);
		} else {
			setRegionId(options.region);
			setAllocationId(e);
			
		}	};

	const filterOption = (input, option) =>
		(option?.label ?? '').toLowerCase().includes(input.toLowerCase());

	const infoContent = (
		<Card size="small" bordered="false" type="inner" style={{ width: 300 }}> 
			<p>{langdata && langdata.realtimedetectioncontent ? langdata.realtimedetectioncontent :'This module is used to list and view different detections across the fiber. By default, detections from the last 1 hour are displayed. Additional filters can be applied to refine the detection data.'}</p>
		</Card>
	);

	const handlepidsfilter = (value) =>{
		setchannels(null);
		setchains(null);
		setpidsFilter(value);
	};

	const handleAisNamefilter = (values) => {
		
		// ALL selected
		if (values.includes(null)) {
			// If ALL was just selected, keep only ALL
			setAisNameFilter([null]);
			return;
		}

		// Normal vessel selection
		setAisNameFilter(values);
	};

	const handleSetChannel = (e,) =>{
		setchannels(e);
	};
	const handleSetAlgorithm = (e,) =>{
		setalgorithm(e);
	};
	const handleSetTrajectory = (e,) =>{
		settrajectory(e);
	};

	const handleFilterDrawer = () => {
		setFilterdrawer(true);
	};

	const onCloseFilterDrawer = () => {
		setFilterdrawer(false);
	};
	const openAddCoordinateModal = () => {
		setShowAddCoordinateModal(true);
	};
	const cloaseAddCoordinateModal = () => {
		setShowAddCoordinateModal(false);
	};

	// ---- Apply button handler — commits the drawer's DRAFT filter values
	// (pidsFilter, channelsdata, chains, algorithm, trajectory, and the
	// computed date range) to the "applied" state, which is what the fetch
	// useEffect actually depends on. This is the ONLY place a filter change
	// results in a new API call — exactly mirroring AlarmReport.jsx's
	// handleFilterAlarm. ----
	const handleFilterDetection = () => {
		const { start, end } = computeDateRange();

		setAppliedPidsFilter(pidsFilter);
		setAppliedChannelsdata(channelsdata);
		setAppliedChains(chains);
		setAppliedAlgorithm(algorithm);
		setAppliedaisNameFilter(aisNameFilter);
		setAppliedTrajectory(trajectory);
		setAppliedStartDate(start);
		setAppliedEndDate(end);

		setFilterdrawer(false);
	};

	const handleAddFormValuesChange = (changedValues)=>{
		
		const key = Object.keys(changedValues)[0];
		const val = changedValues[key];
		if(key ==='PIDS'){
			getChannels(authtoken,val);
			setFilter({...reportFilter,pidsinfoId:val, channelId : 'all'});
			addCoordinateFormik.setFieldValue('pidsinfoId', val);
			addCoordinateFormik.setFieldValue('channelinfoId', null);
			form.setFieldValue('channelinfoId', null);
		}

		if(key==='channelinfoId'){
			setFilter({...reportFilter,channelId:val});
			addCoordinateFormik.setFieldValue('channelinfoId', val);
		}
	};

	// Initial center for the map: the point belonging to the trajectory with
	// the most plotted points (the "primary" detection currently loaded),
	// falling back to the first pipeline point.
	//
	// NOTE: this is only the INITIAL center handed to Leaflet. The live
	// re-centering (fit to the plotted data when there is data, fall back to
	// the PIDS location when there is none) is done inside SeaMap by its
	// <MapAutoCenter /> (enabled via `autoCenter` below), because a
	// MapContainer ignores later changes to its `center` prop.
	//
	// PERFORMANCE: memoized so SeaMap isn't handed a new array every render.
	const mapCenter = useMemo(() => {
		const center = [];
		if (detectionTrajectories && detectionTrajectories.length > 0) {
			const trajectoryWithMaxPoints = detectionTrajectories.reduce((max, traj) => {
				const points = traj.points || [];
				const maxPoints = (max && max.points) || [];
				return points.length > maxPoints.length ? traj : max;
			}, null);

			if (trajectoryWithMaxPoints && trajectoryWithMaxPoints.points && trajectoryWithMaxPoints.points.length > 0) {
				const centerPoint = trajectoryWithMaxPoints.points[0];
				if (centerPoint && centerPoint.lat != null && centerPoint.lng != null) {
					center.push(centerPoint.lat, centerPoint.lng);
				}
			}
		}
		if (center.length === 0) {
			mapdata && mapdata[0] && center.push(mapdata[0].latitude, mapdata[0].longitude);
		}
		return center;
	}, [detectionTrajectories, mapdata]);



	const loadCoordinate = () => {
		let config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: `${api}/coordinates?pipelineId=${parseInt(pipelineId)}&createdAt[$gte]=${startDate.utc().format('YYYY-MM-DD HH:mm:ss')}&createdAt[$lte]=${endDate.utc().format('YYYY-MM-DD HH:mm:ss')}`,
			timeout: timeout,
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
				Authorization: `Bearer ${authtoken}`
			}
		};

		axios
			.request(config)
			.then((response) => {
				if (response.status === 200) {
					dispatch({type: COORDINATE_LIST_SUCCESS, payload: response.data.data});
				}
			})
			.catch((error) => {
				dispatch({type: COORDINATE_LIST_ERROR});
				if (error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
					message.config({
						duration: 5,
						maxCount: 1,
					});
					message.open({
						type: 'error',
						content: langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication
							? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication
							: 'It seems the network is unreachable. Please refresh the application.',
					});
				}
			});
	};

	// ============================================================
	// DELETE a plotted reference coordinate.
	//
	// Wired up as `onDeleteCoordinate` on <SeaMap /> below. SeaMap calls
	// this (via CoordinateDeleteActions inside its Popup) once the user
	// confirms deletion on a plotted coordinate's marker, and awaits the
	// returned Promise to know when to stop showing "Deleting...".
	//
	// Throwing/rejecting on failure keeps the marker on the map (the
	// optimistic removal only happens on success), and the popup's
	// confirm buttons will simply reset back to the "Delete" state.
	//
	// PERFORMANCE: wrapped in useCallback so the prop identity is stable
	// between renders (it only depends on values that rarely change).
	// ============================================================
	const handleDeleteCoordinate = useCallback((coordinate) => {
		const config = {
			method: 'delete',
			url: `${api}/coordinates/${coordinate.id}`,
			timeout,
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${authtoken}`,
			},
		};
	
		return axios.request(config).then((response) => {
			if (response.status === 200 || response.status === 204) {
				setDeletedCoordinateIds((prev) => [...prev, coordinate.id]);
				// or simply: loadCoordinate();
				message.success('Reference coordinate deleted successfully.');
			} else {
				message.error('Unable to delete reference coordinate.');
				throw new Error('Delete failed');
			}
		});
	}, [api, timeout, authtoken]);

	useEffect(() => {
	
		getAISNameFilter();
		// getDetectionClusterVesselData();
		// loadAsnData();
	
	}, [
		// pidsFilter,
		// // vesselFilter,
		// channelsdata,
		// algorithm,
		// timeInterval,
		filterLastHour,
		advDateRange,
		startTime,
		endTime,timeSelection
	]);



	const addCoordinateFormik = useFormik({
		initialValues: {
			latitude: 0,
			longitude: 0,
			pidsinfoId : null,
			channelinfoId : null,
			addName: ''
		},
		onSubmit: (values) => {
			const latitude = values.latitude ? values.latitude : 0;
			const longitude = values.longitude ? values.longitude : 0;
			const name = values.addName ? values.addName : 0;
			const pidsinfoId = values.pidsinfoId ? values.pidsinfoId : null;
			const channelinfoId = values.channelinfoId ? values.channelinfoId : null;
	
			if (!latitude || latitude == null || latitude === '') {
				Modal.warning({ title: langdata && langdata.PleaseprovideavalidManufacturername ? langdata.PleaseprovideavalidManufacturername : 'Please provide a valid Latitude Name.' });
				return false;
			}
			if (!longitude || longitude == null || longitude === '') {
				Modal.warning({ title: langdata && langdata.PleaseprovideavalidModelname ? langdata.PleaseprovideavalidModelname : 'Please provide a valid Longitude Name.' });
				return false;
			}
			if (!name || name == null || name === '') {
				Modal.warning({ title: langdata && langdata.PleaseprovideavalidnameNumber ? langdata.PleaseprovideavalidnameNumber : 'Please provide a valid name Number.' });
				return false;
			}
			if (!pidsinfoId || pidsinfoId == null || pidsinfoId === 0) {
				Modal.warning({ title: langdata && langdata.SelectPIDS ? langdata.SelectPIDS :'Select PIDS' });
				return false;
			}
			
			if (!channelinfoId || channelinfoId == null || channelinfoId === 0) {
				Modal.warning({ title: langdata && langdata.PleaseEnterChannelName ? langdata.PleaseEnterChannelName :'Please Enter Channel Name'});
				return false;
			}
	
			let config = {
				method: 'post',
				maxBodyLength: Infinity,
				url: `${api}/coordinates`,
				timeout: timeout,
				headers: {
					accept: 'application/json',
					'Content-Type': 'application/json',
					Authorization:`Bearer ${authtoken}`
				},
				data: {
					latitude: parseFloat(latitude),
					longitude: parseFloat(longitude),
					channelinfoId : channelinfoId ,
					pidsinfoId : pidsinfoId,
					name: name,
					pipelineId: parseInt(pipelineId)
					
					
				}
			};
	
			dispatch( { type: ADD_COORDINATE_DETAILS }); 
			axios
				.request(config)
				.then((response) => {
					if (response.status === 200 || response.status === 201) {
						dispatch({type: ADD_COORDINATE_DETAILS_SUCCESS, payload: response});
						Modal.success({ title: langdata && langdata.ReferenceCoordinatesAddedsuccessfully ? langdata.ReferenceCoordinatesAddedsuccessfully : 'Reference Coordinates Added Successfully.' });
						setShowAddCoordinateModal(false);
						loadCoordinate();
					} else {
						dispatch({type: ADD_COORDINATE_DETAILS_ERROR});
						Modal.warning({ title: langdata && langdata.UnabletoAddReferenceCoordinates ? langdata.UnabletoAddReferenceCoordinates : 'Unable to Add Reference Coordinates.' });  
					}
				})
				.catch((error) => {
					dispatch({type: ADD_COORDINATE_DETAILS_ERROR});
					if(error.code == 'ECONNABORTED' || error.code == 'ERR_NETWORK') {
						message.config({
							duration : 5,
							maxCount : 1,
						});
						message.open({
							type: 'error',
							content:  langdata && langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication ? langdata.ItseemsthenetworkisunreachablePleaserefreshtheapplication :  'It seems the network is unreachable. Please refresh the application.',
						});
					}
				});
		}
	});

	// ============================================================
	// COORDINATE MARKERS (interrogators) for the map view.
	//
	// Converts the raw API objects:
	//   { id, name, latitude, longitude, channelinfoId, pidsinfoId,
	//     createdAt, channelinfo: { name }, pidsinfo: { name }, ... }
	// into a flat array carrying only what SeaMap needs to plot a marker
	// and show on hover: lat/lng, channel name, pids name, created-at.
	//
	// Memoized on the raw `coordinates` list AND `deletedCoordinateIds`,
	// so it recomputes when either the underlying list changes (e.g.
	// after loadCoordinate() re-fetches) or a coordinate is deleted
	// locally (see handleDeleteCoordinate above) — coordinates whose id
	// is in `deletedCoordinateIds` are filtered out here, which is what
	// makes the marker disappear from the map immediately on delete.
	// ============================================================
	const coordinateMarkers = useMemo(() => {
		const rawCoordinates = realtimedetection_data.coordinates || [];

		return rawCoordinates
			.filter((item) => !deletedCoordinateIds.includes(item?.id))
			.map((item) => {
				const latitude = parseFloat(item?.latitude);
				const longitude = parseFloat(item?.longitude);

				// Skip anything without a valid, plottable position.
				if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
					return null;
				}

				
				return {
					id: item?.id,
					name: item?.name ? item.name : '',
					latitude,
					longitude,
					channelName: item?.channelinfoId ? item.channelinfoId : '',
					pidsName: item?.pidsinfoId ? item.pidsinfoId : '',
					createdAt: item.createdAt ? item.createdAt : '',
					distance : item.distance ? item.distance.toFixed(2) : '',
					ODMeter : item.ODMeter !== null ? item.ODMeter : '',
					fibrelatitude : item.fibrelatitude ? item.fibrelatitude : '',
					fibrelongitude : item.fibrelongitude ? item.fibrelongitude : ''
				};
			})
			.filter(Boolean);
	}, [realtimedetection_data.coordinates, deletedCoordinateIds]);

	const handleDelete = ()=>{
		getRealtimedetectionPatchData();
	};



	return (
		<>
			<Content>
				<Row
					style={{
						margin: '10px',
						paddingLeft: '10px',
						paddingRight: '10px',
						background: '#FFFFFF',
						alignItems:'center',
					}}
				>
					<Col span={4}>
						<Row>
							<Space>
								<FundViewOutlined style={{fontSize:'30px'}}/>
							</Space>
							<Space>&nbsp;&nbsp;</Space>
							<Title level={4} style={{ paddingTop:'10px'}}> {langdata && langdata.RealtimeDetection ? langdata.RealtimeDetection :'Realtime Detection'}</Title>
						</Row>
					</Col>




					<Col style ={{display:'flex',justifyContent:'flex-end'}} span={20} >
						<Row style ={{display:'flex',justifyContent:'flex-end',alignItems:'center'}}>
							<Col span={24} style={{display:'flex',flexWrap:'wrap',justifyContent:'flex-end', alignItems:'center'}}>

								{view === 'List' ? (
									<>
										<Tooltip placement="bottom" title={langdata && langdata.Filterbyregion ? langdata.Filterbyregion :'Filter by region'}>
											<Space>
												<Select Item
													style={{ width: '200px', marginTop:'5px',marginBottom:'5px'}}
													showSearch
													filterOption={filterOption}
													placeholder={langdata && langdata.SelectRegion ? langdata.SelectRegion :'Select Region'}
													optionFilterProp="children"
													options={regions}
													defaultValue={'ALL'}
													value={ admin_roles.includes(permission) ? regionId : allocationId }
													onSelect={(e, options)=>handleSetregion(e, options)}
												/>
											</Space>
										</Tooltip>
										<Space>
											<Button style ={{margin:'5px',marginLeft:'12px'}} type='primary' onClick={handleFilterDrawer}><FilterOutlined /></Button>
										</Space>
									</>
								) : (
									<>
										<Tooltip placement="bottom" title={langdata && langdata.Filterbyregion ? langdata.Filterbyregion :'Filter by region'}>
											<Space>
												<Select
													style={{ minWidth: '200px', textAlign: 'left', margin:'5px'}}
													showSearch
													filterOption={filterOption}
													placeholder={langdata && langdata.SelectRegion ? langdata.SelectRegion :'Select Region'}
													optionFilterProp="children"
													value={ admin_roles.includes(permission) ? regionId : allocationId }
													options={regions}
													onSelect={(e, options)=>handleSetregion(e, options)}
												/>
											</Space>
										</Tooltip>
										<Space>
											<Button style ={{margin:'5px',marginLeft:'8px'}} type='primary' onClick={handleFilterDrawer}><FilterOutlined /></Button>
										</Space>
									</>
								)}

								<Space>
									<Typography>
										<Popover title={langdata && langdata.RealtimeDetection ? langdata.RealtimeDetection :' Realtime Detection'}  content={infoContent} trigger="click">
											<Avatar size="small" style={{marginTop:'5px',marginBottom:'5px',marginLeft:'8px',cursor:'pointer'}}><InfoOutlined /></Avatar>
										</Popover>
									</Typography>
								</Space>
							</Col>
						</Row>
					</Col>
				</Row>

				<Modal
					title={langdata && langdata.AddReferenceCoordinates ? langdata.AddReferenceCoordinates : 'Add Reference Coordinates' }
					centered
					destroyOnClose={true}
					maskClosable={false}
					open={showAddCoordinateModal}
					onOk={{cloaseAddCoordinateModal}}
					onCancel={cloaseAddCoordinateModal}
					footer={[
					// eslint-disable-next-line react/jsx-key
						<Space>
							<Button onClick={cloaseAddCoordinateModal}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE' }</Button>
							{ permission === 'superadmin' || permission === 'admin' ? <Button type="primary" onClick={addCoordinateFormik.handleSubmit}>{langdata && langdata.SAVE ? langdata.SAVE : 'SAVE' }</Button> : null }
						</Space>
					]}
					width={800}
				>
					<Form layout="vertical" onSubmit={addCoordinateFormik.handleSubmit}>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="name" label={langdata && langdata.Name ? langdata.Name : 'Name'} rules={[{ required: true, message: langdata && langdata.Pleaseenterthename ? langdata.Pleaseenterthename : 'Please enter the name' }]} >
									<Input name="addName" onChange={addCoordinateFormik.handleChange} placeholder={langdata && langdata.Pleaseenterthename ? langdata.Pleaseenterthename : 'Please enter the name'} />
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="PIDS" label={ langdata&&langdata.PIDS?langdata.PIDS:'PIDS'} rules={[{ required: true, message: langdata && langdata.SelectPIDS ? langdata.SelectPIDS :'Select PIDS'}]} >
									<Select Item
										name="PIDS"
										style={{ width: '100%'}}
										showSearch
										filterOption={filterOption}
										placeholder={langdata && langdata.SelectPIDS ? langdata.SelectPIDS :'Select PIDS'}
										optionFilterProp="children"
										// value={reportFilter.pidsinfoId}
										value={reportFilter.pidsinfoId}
										onSelect={(value)=>{handleAddFormValuesChange({'PIDS': value});}}             
										options={pids}
									/>
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="channelinfoId" label={ langdata&&langdata.channelName?langdata.channelName:'channel Name'} rules={[{ required: true, message: langdata && langdata.PleaseEnterChannelName ? langdata.PleaseEnterChannelName :'PleaseEnterChannelName'}]} >
									<Select Item
										style={{ width : '100%'}}
										name="channelinfoId"
										showSearch
										filterOption={filterOption}
										disabled={reportFilter.pidsinfoId ? false :true}
										placeholder={langdata && langdata.PleaseEnterChannelName ? langdata.PleaseEnterChannelName :'Please Enter Channel Name'}
										optionFilterProp="children"	
										onSelect={(value)=>{handleAddFormValuesChange({'channelinfoId': value});}}
										value={addCoordinateFormik.values.channelinfoId}
										// onSelect={handleSetChannel}
										options={channels}
															
									/>
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="latitude" label={langdata && langdata.Latitude ? langdata.Latitude : 'Latitude'} rules={[{ required: true, message: langdata && langdata.PleaseenterLatitude ? langdata.PleaseenterLatitude : 'Please enter the Latitude' }]} >
									<Input name="latitude" onChange={addCoordinateFormik.handleChange} placeholder={langdata && langdata.PleaseenterLatitude ? langdata.PleaseenterLatitude : 'Please enter Latitude'} />
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item name="longitude" label={langdata && langdata.Longitude ? langdata.Longitude : 'Longitude'} rules={[{ required: true, message: langdata && langdata.PleaseentertheLongitude ? langdata.PleaseentertheLongitude : 'Please enter the Longitude Name' }]} >
									<Input name="longitude" onChange={addCoordinateFormik.handleChange} placeholder={langdata && langdata.PleaseentertheLongitude ? langdata.PleaseentertheLongitude : 'Please enter the Longitude Name'} />
								</Form.Item>
							</Col>
						</Row>
						
					</Form>
				</Modal>

				<Row style={{
					margin: '10px',
					padding:'10px',
					paddingBottom:'2px',
					background: '#FFFFFF',
					alignItems:'center',
				}}>
					<Col span={12}>
						<Radio.Group
							style={{ margin: '0 0 10px 0' }}
							value={view}
							onChange={(e) => setView(e.target.value)}
						>
							<Radio.Button value="List">
								{langdata && langdata.List ? langdata.List : 'List'}
							</Radio.Button>
							<Radio.Button value="Map">
								{langdata && langdata.Map ? langdata.Map : 'Map'}
							</Radio.Button>
						</Radio.Group>
					</Col>
					{view === 'Map' ? <Col span={12}>
						<Row justify="end">
							<Col>
								<Tooltip placement="bottom" title={langdata && langdata.Add ? langdata.Add : 'Add'}>
									<Space>
										{/* { permission === 'superadmin' || permission === 'admin' ? <Button type="primary"  style={{marginBottom:'10px'}} ><PlusOutlined/>{langdata && langdata.AddNew ? langdata.AddNew : 'Add New' }</Button> : null } */}
										{  <Button type="primary"  style={{marginBottom:'10px'}} onClick={openAddCoordinateModal} ><PlusOutlined/>{langdata && langdata.AddNew ? langdata.AddNew : 'Add New' }</Button> }
									</Space>
								</Tooltip>
								{/* <Space>&nbsp;&nbsp;</Space> */}
							</Col>
						</Row>
					</Col> : null}
				</Row>

				{view === 'List' ? (
					<Row span={24} style={{
						margin: '10px',
						paddingLeft: '10px',
						paddingRight: '10px',
						background: '#FFFFFF',
						alignItems:'center'
					}} >
						<Col span={24}>
							{ Realtimedetectiondata.length > 0 ? (
								<Table 
									scroll={{
										x: 900,
									}}
									columns={columns} dataSource={Realtimedetectiondata}
									pagination = { Realtimedetectiondata.length > 0 ? realtimedetection_data_pagination  : 0}
									onChange = { getRealtimedetectiondata }
								/>
							)
								:
								(
									<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
								)}
						</Col>
					</Row>
				) : (
					<Row span={24} style={{
						margin: '10px',
						paddingLeft: '10px',
						paddingRight: '10px',
						background: '#FFFFFF',
						alignItems:'center'
					}} >
						<Col span={24}>
							{map_type && map_type !== 'leaflet' ? (
								<GoogleMap datadetection={Realtimedetectiondata} height={'70vh'} coordinatesData={coordinateMarkers} onDeleteCoordinate={handleDeleteCoordinate} showAISVessels={true} />
							) : (
								<div className="App" style={{ textAlign: 'left', margin: '10px', height: '70vh' }}>
									<SeaMap
										center={mapCenter.length > 0 ? mapCenter : undefined}
										zoom={14}
										style={SEAMAP_STYLE}
										mapContainerProps={SEAMAP_CONTAINER_PROPS}
										autoCenter={true}
										pipelineTracks={pipelineTracks}
										fiberTracks={fiberTracks}
										pipelineBorderTracks={pipelineBorderTracks}
										optionalPathTracks={optionalPathTracks}
										kmpMarkers={KMP}
										wbMarkers={WB}
										tpMarkers={Turn}
										tlpMarkers={TLP}
										chMarkers={CH}
										detectionTrajectories={detectionTrajectories}
										distanceRangeTracks={distanceRangeTracks}
										asnData={ASNdata}
										layersControlChildren={pipelineLayersControlChildren}
										mapChildren={realtimeDetectionPlayMapChildren}
										showTrajectoryPlayControl={false}
										showAISVessels={true}
										hiddenTrajectoryCpaIds={hiddenTrajectoryCpaIds}
										coordinatesData={coordinateMarkers}
										onDeleteCoordinate={handleDeleteCoordinate}
									/>
								</div>
							)}
						</Col>
					</Row>
				)}

				<Drawer
					title={langdata && langdata.Filteroptions ? langdata.Filteroptions : 'Filter options'}
					onClose={onCloseFilterDrawer}
					open={filterDrawer}
				>
					<Form layout="vertical">
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item label={langdata && langdata.FilterbyTrajectoryMethod ? langdata.FilterbyTrajectoryMethod : 'Filter by Trajectory Method'}>
									<Select
										showSearch
										filterOption={filterOption}
										placeholder={langdata && langdata.SelectTrajectoryMethod ? langdata.SelectTrajectoryMethod : 'Select Trajectory Method'}
										optionFilterProp="children"
										value={trajectory}
										options={trajectoryOptions}
										onSelect={(e) => handleSetTrajectory(e)}
									/>
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item label={langdata && langdata.Filterbypids ? langdata.Filterbypids : 'Filter by PIDS'}>
									<Select
										showSearch
										filterOption={filterOption}
										placeholder={langdata && langdata.SelectPIDS ? langdata.SelectPIDS : 'Select PIDS'}
										optionFilterProp="children"
										value={pidsFilter}
										options={pidsfilter}
										onSelect={handlepidsfilter}
									/>
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item label={langdata && langdata.Filterbychannel ? langdata.Filterbychannel : 'Filter by Channel'}>
									<Select
										showSearch
										filterOption={filterOption}
										placeholder={langdata && langdata.SelectChannel ? langdata.SelectChannel : 'Select Channel'}
										optionFilterProp="children"
										value={channelsdata}
										options={channels}
										disabled={pidsFilter == null}
										onSelect={(e) => handleSetChannel(e)}
									/>
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={24}>
								<Form.Item label={langdata && langdata.FilterbyAlgorithm ? langdata.FilterbyAlgorithm : 'Filter by Algorithm'}>
									<Select
										showSearch
										filterOption={filterOption}
										placeholder={langdata && langdata.SelectAlgorithm ? langdata.SelectAlgorithm : 'Select Algorithm'}
										optionFilterProp="children"
										value={algorithm}
										options={algorithamOptions}
										onSelect={(e) => handleSetAlgorithm(e)}
									/>
								</Form.Item>
							</Col>
						</Row>

						<Row gutter={24}>
							<Col span={24}>
								<Form.Item label={langdata && langdata.DetectionsinLast ? langdata.DetectionsinLast : 'Detections in Last'}>
									<Select
										showSearch
										filterOption={filterOption}
										placeholder={langdata && langdata.SelectTime ? langdata.SelectTime : 'Select Time'}
										optionFilterProp="children"
										value={filterLastHour}
										options={lastHours}
										onSelect={handleLastHour}
										disabled={timeSelection}
									/>
								</Form.Item>
							</Col>
						</Row>

						{ timeSelection === true ? null :
							<> 
								<Row gutter={24}>
									<Col span={24}>
										<Form.Item label={langdata && langdata.FilterbyAISName ? langdata.FilterbyAISName : 'Filter by AIS Name'}>
											<Select
												showSearch
												mode="multiple"
												filterOption={filterOption}
												placeholder={langdata && langdata.SelectAISName ? langdata.SelectAISName : 'Select AIS Name'}
												optionFilterProp="children"
												value={aisNameFilter}
												options={aisNameOptions}
												onChange={handleAisNamefilter}
											/>
										</Form.Item>
									</Col>
								</Row>
							</>
						}	

						<Row gutter={24}>
							<Col span={24}>
								<Checkbox onChange={changeTimeSelection} checked={timeSelection}>{langdata && langdata.Advancedoptions ? langdata.Advancedoptions : 'Advanced options'}</Checkbox>
							</Col>
						</Row>

						{timeSelection === true ? (
							<>
								<Row gutter={24} style={{ marginTop: '20px' }}>
									<Col span={24}>
										<Form.Item label={langdata && langdata.Date ? langdata.Date : 'Date'}>
											<RangePicker
												onChange={handleAdvDateRange}
												style={{ minWidth: '100%' }}
												disabledDate={disabledDate}
												allowClear={false}
												format={`${settingsdateformat}`}
												value={advDateRange}
											/>
										</Form.Item>
									</Col>
								</Row>
								<Row gutter={24}>
									<Col span={24}>
										<Form.Item label={langdata && langdata.StartTime ? langdata.StartTime : 'Start Time'}>
											<TimePicker allowClear={false} onChange={handleStartTime} style={{ minWidth: '100%' }} value={startTime} />
										</Form.Item>
									</Col>
								</Row>
								<Row gutter={24}>
									<Col span={24}>
										<Form.Item label={langdata && langdata.EndTime ? langdata.EndTime : 'End Time'}>
											<TimePicker allowClear={false} onChange={handleEndTime} style={{ minWidth: '100%' }} value={endTime} />
										</Form.Item>
									</Col>
								</Row>
								<Row gutter={24}>
									<Col span={24}>
										<Form.Item label={langdata && langdata.FilterbyAISName ? langdata.FilterbyAISName : 'Filter by AIS Name'}>
											<Select
												showSearch
												mode="multiple"
												filterOption={filterOption}
												placeholder={langdata && langdata.SelectAISName ? langdata.SelectAISName : 'Select AIS Name'}
												optionFilterProp="children"
												value={aisNameFilter}
												options={aisNameOptions}
												onChange={handleAisNamefilter}
											/>
										</Form.Item>
									</Col>
								</Row>
							</>
						) : null}

						<Row gutter={24}>
							<Col span={12} style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
								<Button type='primary' onClick={handleFilterDetection}>{langdata && langdata.Apply ? langdata.Apply : 'Apply'}</Button>
							</Col>
							<Col span={12} style={{ display: 'flex', marginTop: '10px' }}>
								<Button onClick={onCloseFilterDrawer}>{langdata && langdata.Close ? langdata.Close : 'Close'}</Button>
							</Col>
						</Row>
					</Form>
				</Drawer>
				<Modal
					title={langdata && langdata.Confirmaction ? langdata.Confirmaction : 'Confirm Action'}
					centered
					open={modalOpen}
					onOk={handleDelete}
					onCancel={() => setModalOpen(false)}
					footer={[
						// eslint-disable-next-line react/jsx-key
						<Space>
							<Button onClick={() => setModalOpen(false)}>{langdata && langdata.CLOSE ? langdata.CLOSE : 'CLOSE'}</Button>
							<Button key="submit" type="primary" onClick={handleDelete}>{langdata && langdata.HIDE ? langdata.HIDE : 'HIDE'}</Button>
						</Space>
					]}
				>
					{/* <Typography style={{color:'red', display:'flex', fontSize:'17px'}}>{langdata && langdata.Thisupdatewilldeleteallyourlowerrolesallocations ? langdata.Thisupdatewilldeleteallyourlowerrolesallocations : 'This update will delete all your lower roles allocations.'}</Typography> */}
					{/* <Space>&nbsp;</Space> */}
					<p>
						{langdata && langdata.AreYouSureYouWantToHideThisDetection
							? langdata.AreYouSureYouWantToHideThisDetection
							: 'Are you sure you want to hide this Detection ?'}
					</p>
				</Modal>

				{/* Detection info modal — title is the algorithm name.
				    `trajectory` is passed as-is: truthy -> correctedDetectionResults,
				    otherwise -> detectionResults (the decision is made inside the modal). */}
				<DetectionInfoModal
					open={infoModalOpen}
					record={infoRecord}
					modalData={realtimedetection_data.modaldata}
					modalLoading={realtimedetection_data.modalPending}
					onClose={closeInfoModal}
					trajectoryBoolean={trajectory}
				/>

			</Content>

			<Spin spinning={realtimedetection_data.pending} fullscreen />

		</>
	);
}